const translations = {
    // Avis Google authentiques
    reviews_source: "Avis Google · 5/5",
    reviews_previous: "Précédent",
    reviews_next: "Suivant",
    reviews_pause: "Pause",
    reviews_play: "Lecture",
    reviews_visiter_surtitle: "Expériences de visite",
    reviews_visiter_title: "Ils ont visité la Villa",
    reviews_dormir_surtitle: "Séjours au château",
    reviews_dormir_title: "Ils ont dormi à la Villa",
    reviews_mariage_surtitle: "Paroles de mariés",
    reviews_mariage_title: "Ils ont célébré leur union ici",
    review_visit_1: "Une visite merveilleuse dans un endroit merveilleux ! L'audioguide est très bien fait pour permettre une visite en autonomie.",
    review_visit_2: "J'ai visité le château. Très belles pièces avec de belles tapisseries, instruments de musique, tableaux et sculptures. Et une grande bibliothèque.",
    review_visit_3: "Très très beau lieu, les papiers peints notamment sont exceptionnels, le mobilier très intéressant et l'audioguide très bien fait.",
    review_visit_4: "Un véritable coup de cœur ! La Villa Palladienne est un lieu absolument magnifique, chargé d’histoire et plein de charme.",
    review_visit_5: "Merci aux propriétaires d'ouvrir cette merveille au public, merci pour la conservation de l'authenticité de la villa.",
    review_visit_6: "Découverte de cette superbe villa à visiter absolument. Accueil très sympathique par le propriétaire.",
    review_sleep_1: "Nous sommes ravis d'avoir passé une nuit dans la chambre Joséphine. Très belle chambre avec un grand lit confortable, petit déjeuner au top, tout comme l'accueil, merci !",
    review_sleep_2: "Le petit déjeuner fut à la hauteur du lieu et la nuitée des plus calme dans la chambre Amélie magnifiquement décorée.",
    review_sleep_3: "Chambre encore plus belle que les photos ne le laissent paraître, petit déjeuner à la hauteur du cadre somptueux.",
    review_sleep_4: "On se sent chez soi mais hors du temps dans des chambres immenses à la vue panoramique sur le parc et meublées d'époque.",
    review_sleep_5: "Lieu incroyable, nous revenons ici chaque année. Le petit déjeuner en chambre d’hôte est incroyable.",
    review_sleep_6: "Les chambres de la Villa ont également été très appréciées pour leur confort et leur beauté.",
    review_wedding_1: "Nous tenons à remercier chaleureusement toute l’équipe de la Villa Palladienne de Syam pour avoir contribué à faire de notre mariage un moment inoubliable.",
    review_wedding_2: "Un lieu magnifique pour le week-end de notre mariage ! Les propriétaires ont su être disponibles et répondre à nos différentes demandes !",
    review_wedding_3: "L'endroit est magnifique et très adapté au mariage. Les propriétaires sont bienveillants et répondent à toutes vos demandes.",
    review_wedding_4: "J'ai eu la chance d'y accompagner un couple pour leurs photos de mariage. Cet établissement est un véritable bijou caché, niché au cœur d'un paysage verdoyant.",
    review_wedding_5: "Lieu sublime ! Authentique et habité par des propriétaires charmants et passionnés.",
    review_visit_7: "Quelle superbe villa. Un lieu incroyable. Le bâtiment extérieur est, bien sûr, magnifique, mais l’intérieur réserve de belles surprises !",
    review_sleep_7: "Très bel accueil, une villa somptueuse au milieu d'un écrin de forêt jurassienne. À faire absolument, pour une visite voire une nuit en chambre d'hôtes.",
    review_sleep_8: "Magnifique château de Syam dans le Jura, avec une visite guidée et des chambres d'hôtes dans des suites royales. À voir absolument.",
    review_sleep_9: "Lieu magique. Chambres d'hôtes et salle de réception dans un écrin de verdure.",
    review_wedding_6: "En plus de la visite, nous avons assisté à la préparation du lieu pour un mariage. Je vous recommande de visiter ce lieu si vous passez dans le Jura.",
    reviews_leave: "Laisser un avis",
    reviews_more: "Voir plus d'avis",
    reviews_previous_mobile: "Préc.",
    reviews_next_mobile: "Suiv.",
    reviews_more_mobile: "Plus",
    reviews_rating: "4,8/5",
    reviews_page_surtitle: "Témoignages vérifiés",
    reviews_page_title: "Les avis de nos visiteurs",
    reviews_page_intro: "Retrouvez ici une sélection d’avis publiés par nos visiteurs sur Google, classés selon leur expérience.",
    reviews_filter_label: "Filtrer les avis par expérience",
    reviews_filter_all: "Tous les avis",
    reviews_filter_visiter: "Visite",
    reviews_filter_dormir: "Chambres",
    reviews_filter_mariage: "Mariage",
    reviews_page_count: "avis authentiques",
    reviews_page_source_link: "Consulter l’avis sur Google",
    reviews_page_source_note: "Extraits issus d’avis publiés sur Google.",
    home_seo_title: "Château de Syam — Villa Palladienne | Jura",
    home_seo_description: "Château de Syam : villa néo-palladienne classée, visites guidées, chambres d'hôtes, gîtes, mariages et événements dans le Jura.",
    home_h2: "Visites, séjours, mariages et événements dans le Jura",
    reviews_page_seo_title: "Avis clients — Château de Syam",
    reviews_page_seo_description: "Découvrez les avis Google authentiques des visiteurs, hôtes et mariés de la Villa Palladienne — Château de Syam.",
    reviews_page_seo_keywords: "avis Château de Syam, avis Villa Palladienne, avis chambres d'hôtes Jura, avis mariage château Jura",
    // Visite audioguidée
    audio_guide_seo_title: "Visite audioguidée — Château de Syam",
    audio_guide_seo_description: "Écoutez la visite audioguidée de la Villa Palladienne — Château de Syam, en français, anglais, allemand ou néerlandais.",
    audio_guide_eyebrow: "Château de Syam",
    audio_guide_heading: "Visite audioguidée",
    audio_guide_intro: "Merci de sélectionner votre langue.",
    audio_guide_select_label: "Choisir une langue",
    audio_guide_language_fr: "Français",
    audio_guide_language_en: "Anglais",
    audio_guide_language_de: "Allemand",
    audio_guide_language_nl: "Néerlandais",
    audio_guide_track: "Piste",
    audio_guide_audio_unsupported: "Votre navigateur ne prend pas en charge la lecture audio.",
    // Navigation
    nav_home: "Accueil",

    // Hero (new keys)
    hero_discover: "Découvrir",
    hero_book: "Réserver",
    hero_book_visit: "Réserver une visite",

    // Stats bar
    stat_founded: "Fondée en",
    stat_history: "Ans d'histoire",
    stat_park: "Hectares de parc",
    stat_guests: "Convives max.",
    stat_year: "Année de construction",
    stat_years: "Ans d'histoire",
    stat_room: "Salle de réception",

    // Intro section
    intro_label: "Bienvenue",
    intro_title: "Une demeure d'exception",
    intro_text: "Édifiée en 1818 par Emmanuel Jobez, la Villa Palladienne est un monument historique classé, unique en France. Nichée dans le Jura, cette villa néo-palladienne vous ouvre ses portes pour des visites commentées, des séjours en chambres d'hôtes, des gîtes et des réceptions de mariage inoubliables.",

    // Activities grid
    visit_label: "Patrimoine",
    visit_title: "Visiter la Villa",
    visit_intro_text: "Plongez dans l'histoire flamboyante d'une famille de Maîtres de Forges jurassiens. Visites commentées par les propriétaires passionnés, {periode}, {jours_heures}{fermes_paren}.",
    visit_desc: "Plongez dans l'histoire flamboyante d'une famille de Maîtres de Forges jurassiens. Visites commentées par les propriétaires passionnés, {periode}, {jours_heures}{fermes_paren}.",
    visit_cta: "Découvrir les visites",
    stay_label: "Séjour",
    stay_title: "Dormir au Château",
    stay_text: "Chambres d'hôtes et gîtes au cœur du château. Petit-déjeuner gourmand servi en chambre ou en terrasse. Une expérience unique dans un cadre d'exception.",
    stay_desc: "Séjournez dans nos chambres d'hôtes ou nos gîtes et vivez une expérience unique dans ce cadre exceptionnel. Petit-déjeuner gourmand inclus.",
    stay_cta: "Voir les hébergements",
    wedding_label: "Célébration",
    wedding_title: "Mariages & Réceptions",
    wedding_text: "La Villa dispose de magnifiques dépendances en forme de Fer à Cheval pour accueillir jusqu'à 150 convives. Parc de 10 hectares, cuisine professionnelle, terrasse plein ouest.",
    wedding_desc: "La Villa dispose de magnifiques dépendances pour accueillir jusqu'à 150 convives dans un cadre romantique incomparable. Parc de 10 hectares, cuisine professionnelle.",
    wedding_cta: "Organiser votre mariage",

    // Heritage section
    heritage_label: "Notre patrimoine",
    heritage_title: "Trois siècles d'histoire",
    heritage_arch_label: "Architecture",
    heritage_arch_title: "Architecture néo-palladienne",
    heritage_arch_text: "Un carré de 24m × 24m, 8 colonnes néoclassiques, une rotonde centrale. La Villa est unique en France, inspirée de la Villa Rotonda de Palladio.",
    heritage_arts_label: "Arts décoratifs",
    heritage_arts_title: "Papiers peints & mobilier",
    heritage_arts_text: "La plus importante collection de papiers peints panoramiques du XIXe siècle dans une maison ouverte au public. Mobilier Empire, Restauration, Charles X.",
    heritage_park_label: "Parc & Nature",
    heritage_park_title: "10 hectares de parc",
    heritage_park_text: "Un parc de 10 hectares s'étend autour de la Villa. Terrasse plein ouest, jardins à la française, vue sur la vallée de l'Ain.",
    // History section
    history_label: "Histoire",
    history_title: "Un monument d'exception",
    history_text1: "Édifiée à partir de 1818 par Emmanuel Jobez, la Villa Palladienne est une demeure au plan carré, centrée sur un péristyle de huit colonnes, dans l'esprit des belles villas italiennes du Maître Andrea Palladio.",
    history_text2: "Les Jobez, de pères en fils, ont considérablement influencé la vie politique, sociale et économique du Jura au 19ème siècle. Leur demeure est aujourd'hui un monument historique classé, unique en France.",
    history_cta: "Découvrir l'histoire",

    // CTA section
    cta_label: "Réservation",
    cta_title: "Vivez l'expérience Villa Palladienne",
    cta_text: "Que ce soit pour une visite commentée, un séjour en chambres d'hôtes ou l'organisation de votre mariage, notre équipe est à votre disposition pour vous accueillir.",
    cta_contact: "Nous contacter",

    nav_villa: "La Villa",
    nav_visit: "Visiter",
    nav_accommodation: "Hébergement",
    nav_wedding: "Mariages",
    nav_contact: "Contact",
    nav_reserve: "Réserver",

    // Hero
    hero_subtitle: "Château de Syam — Jura",
    hero_title: "La Villa Palladienne",
    hero_tagline: "Une demeure d'exception au cœur du Jura",
    hero_cta: "Découvrir",
    hero_reserve: "Réserver une visite",

    // Home sections
    home_visit_label: "Patrimoine",
    home_visit_title: "Visiter la Villa",
    home_visit_text: "Plongez dans l'histoire flamboyante d'une famille de Maîtres de Forges jurassiens du 19ème siècle. Visites commentées {periode}, {jours_heures}{fermes_paren}.",
    home_visit_cta: "En savoir plus",
    home_sleep_label: "Séjour",
    home_sleep_title: "Dormir au Château",
    home_sleep_text: "Séjournez dans nos chambres d'hôtes ou nos gîtes et vivez une expérience unique dans ce cadre exceptionnel. Petit-déjeuner gourmand inclus.",
    home_sleep_cta: "Voir les hébergements",
    home_wedding_label: "Célébration",
    home_wedding_title: "Mariages & Réceptions",
    home_wedding_text: "La Villa dispose de magnifiques dépendances en forme de Fer à Cheval pour accueillir jusqu'à 150 convives dans un cadre romantique incomparable.",
    home_wedding_cta: "Organiser votre mariage",
    home_about_label: "Histoire",
    home_about_title: "Un monument d'exception",
    home_about_text: "Édifiée en 1818 par Emmanuel Jobez, la Villa Palladienne est une demeure au plan carré, centrée sur un péristyle de huit colonnes, dans l'esprit des belles villas italiennes du Maître Andrea Palladio.",
    home_about_cta: "Découvrir l'histoire",
    home_stats_years: "Ans d'histoire",
    home_stats_guests: "Convives max.",
    home_stats_hectares: "Hectares de parc",
    home_stats_rooms: "Pièces meublées",

    // Villa page
    villa_label: "Patrimoine",
    villa_title: "La Villa Palladienne",
    villa_intro_label: "Bienvenue",
    villa_intro_title: "La Villa Palladienne de Syam",
    villa_intro_text: "Joyau de l'architecture néo-palladienne, la Villa Palladienne est un monument historique classé, édifié en 1818 par Emmanuel Jobez. Unique en France, elle vous invite à découvrir deux siècles d'histoire, d'arts et de vie de château.",
    villa_history_text3: "Aujourd'hui, la Villa Palladienne est un monument historique classé, ouvert au public {periode}. Les actuels propriétaires vous accueillent personnellement pour des visites commentées passionnantes.",
    villa_history_label: "Histoire",
    villa_history_title: "Un peu d'histoire",
    villa_history_text1: "La Villa Palladienne a été édifiée à partir de 1818. Son commanditaire Emmanuel Jobez était le fils de Claude Jobez, Maître de Forges et homme politique reconnu. Les Jobez, de pères en fils, ont considérablement influencé la vie politique, sociale et économique du Jura au 19ème siècle.",
    villa_history_text2: "Emmanuel fut l'héritier de ce fabuleux parcours. À l'occasion d'un voyage en Italie, il tomba sous le charme de l'œuvre d'Andrea Palladio, grand architecte de la renaissance italienne. Il imagina faire construire à Syam une réplique de la célèbre Villa Rotonda construite au XVIème siècle à Vicence.",
    villa_archi_label: "Architecture",
    villa_archi_title: "Entre néoclassicisme et néopalladianisme",
    villa_archi_text: "À mille lieues de l'Italie, plongez dans l'art de vivre des palais vénitiens de la Renaissance. La Villa est un carré de 24 m × 24 m et de 16 m de haut, avec 8 grandes pièces par niveau distribuées par une rotonde centrale soutenue par 8 colonnes néoclassiques.",
    villa_figure8_label: "Curiosité",
    villa_figure8_title: "Le chiffre 8",
    villa_figure8_text: "Toutes les côtes de la Villa sont des multiples du chiffre 8. La maison est un carré de 24 mètres par 24 et de 16 mètres de haut. 8 grandes pièces par niveau, 8 colonnes, 8 marches pour accéder à la maison.",
    villa_arts_label: "Arts décoratifs",
    villa_arts_papiers: "Papiers peints",
    villa_arts_mobilier: "Mobilier d'époque",
    villa_arts_parquets: "Parquets & Lustres",
    villa_arts_title: "Une collection unique",
    villa_arts_text: "La Villa abrite la plus importante collection de papiers peints panoramiques du XIXème siècle dans une maison ouverte au public. Zuber, Defossé, Leroy, Pierce-Fontaine, Mader, Joseph Dufour… Chaque pièce est un décor unique.",
    villa_furniture_label: "Mobilier",
    villa_furniture_title: "Entièrement meublée d'époque",
    villa_furniture_text: "La maison bénéficie de son ameublement d'origine : mobilier bourgeois d'époque Empire, Restauration, Charles X et Louis-Philippe. Les acajous de Cuba et les marqueteries précieuses en font une collection aussi diversifiée qu'harmonieuse.",
    villa_library_label: "Bibliothèque",
    villa_library_title: "La bibliothèque de Syam",
        villa_library_text: "Au deuxième étage, Emmanuel Jobez disposait d'une somptueuse bibliothèque de 24 mètres de long, pouvant contenir jusqu'à 36 000 ouvrages. Les actuels propriétaires reconstituent patiemment cette collection.",
    // Visit page
    visit_hours_label: "Horaires",
    visit_hours_title: "Ouverture au public",
    visit_hours_text: "La Villa est ouverte {jours_heures}{fermes_paren}, {periode}.",
    visit_season: "{Periode}",
    visit_time: "{jours_heures_court}",
    visit_price_label: "Tarifs",
    visit_price_title: "Nos tarifs",
    visit_adult: "Adulte",
    visit_child: "Enfant (- de 12 ans)",
    visit_group: "Groupe (+ de 10 pers.)",
    visit_free: "Gratuit",
    visit_form_label: "Réservation",
    visit_form_title: "Réserver une visite commentée",
    visit_form_date: "Date de visite",
    visit_form_adults: "Nombre d'adultes",
    visit_form_children: "Nombre d'enfants",
    visit_form_firstname: "Prénom",
    visit_form_lastname: "Nom",
    visit_form_email: "Adresse e-mail",
    visit_form_phone: "Téléphone",
    visit_form_message: "Message (optionnel)",
    visit_form_submit: "Confirmer la réservation",
    visit_form_success: "Votre demande de réservation a bien été envoyée. Nous vous contacterons sous 24h.",

    // Accommodation page
    accom_label: "Séjour",
    accom_title: "Dormir au Château",
    accom_rooms_label: "Chambres d'hôtes",
    accom_rooms_title: "Chambres à la Villa",
    accom_rooms_text: "Nous vous accueillons en chambres d'hôtes avec petit-déjeuner gourmand servi en chambre ou en terrasse. Sérénité des lieux, luxe authentique des chambres.",
    accom_gites_label: "Gîtes",
    accom_gites_title: "Les Gîtes du Fer à Cheval",
    accom_gites_text: "Face à la Villa Palladienne, les anciennes écuries réhabilitées en gîtes permettent d'accueillir des groupes ou des familles dans un cadre exceptionnel.",
    accom_dates: "Ouvert {periode}",
    accom_breakfast: "Petit-déjeuner gourmand inclus",
    accom_visit_included: "Visite du château incluse",
    accom_per_night: "/ nuit",
    accom_per_stay: "/ séjour (2 nuits min.)",
    accom_max: "personnes max.",
    accom_book: "Réserver",
    accom_form_title: "Réserver",
    accom_form_checkin: "Date d'arrivée",
    accom_form_checkout: "Date de départ",
    accom_form_adults: "Nombre d'adultes",
    accom_form_children: "Nombre d'enfants",
    accom_form_firstname: "Prénom",
    accom_form_lastname: "Nom",
    accom_form_email: "Adresse e-mail",
    accom_form_phone: "Téléphone",
    accom_form_message: "Message (optionnel)",
    accom_form_submit: "Envoyer la demande",
        accom_form_success: "Votre demande de réservation a bien été envoyée. Nous vous contacterons sous 24h.",
    // Wedding page
    wedding_intro: "Votre mariage est décidé. Organisez votre journée inoubliable dans un endroit de rêve : la Villa Palladienne à Syam, près de Champagnole.",
    wedding_room_label: "Salle de réception",
    wedding_room_title: "Un cadre d'exception",
    wedding_room_text: "La Villa dispose de magnifiques dépendances en forme de Fer à Cheval récemment restaurées pour accueillir dans un cadre romantique jusqu'à 150 convives.",
    wedding_room_size: "170 m²",
    wedding_room_guests: "150 convives",
    wedding_room_kitchen: "Cuisine professionnelle",
    wedding_room_terrace: "Terrasse plein ouest",
    wedding_park_label: "Parc",
    wedding_park_title: "10 hectares de parc",
    wedding_park_text: "Une grande terrasse au charme incomparable s'ouvre sur un parc de 10 hectares. Le lieu est particulièrement adapté pour déjeuner ou dîner à l'intérieur ou en terrasse.",
    wedding_testimonials_label: "Témoignages",
    wedding_testimonials_title: "Ils nous ont confié leur plus beau jour",
    wedding_form_label: "Contact",
    wedding_form_title: "Demander un devis",
    wedding_form_firstname: "Prénom",
    wedding_form_lastname: "Nom",
    wedding_form_email: "Adresse e-mail",
    wedding_form_phone: "Téléphone",
    wedding_form_date: "Date souhaitée",
    wedding_form_guests: "Nombre de convives",
    wedding_form_type: "Type d'événement",
    wedding_form_message: "Votre projet (décrivez votre événement)",
    wedding_form_submit: "Envoyer la demande",
    wedding_form_success: "Votre demande a bien été envoyée. Nous vous contacterons très prochainement.",

    // Contact page
    contact_label: "Nous trouver",
    contact_title: "Contactez-nous",
    contact_address: "Adresse",
    contact_phone: "Téléphone",
    contact_email: "E-mail",
    contact_hours: "Horaires",
    contact_hours_text: "Ouvert {periode}, {jours_heures}{fermes_paren}",
    contact_form_title: "Envoyez-nous un message",
    contact_form_firstname: "Prénom",
    contact_form_lastname: "Nom",
    contact_form_email: "Adresse e-mail",
    contact_form_phone: "Téléphone",
    contact_form_message: "Votre message",
    contact_form_submit: "Envoyer",
    contact_form_success: "Votre message a bien été envoyé. Merci !",

    // Footer
    footer_newsletter_title: "Programme culturel",
    footer_newsletter_text: "Recevez les événements à venir et les dernières actualités.",
    footer_newsletter_placeholder: "Votre adresse e-mail",
    footer_newsletter_submit: "S'inscrire",
    footer_newsletter_success: "Merci pour votre inscription !",
    footer_newsletter_consent: "J'accepte la politique de confidentialité",
    footer_legal: "Mentions légales",
    footer_privacy: "Politique de confidentialité",
    footer_cgv: "CGV",
    footer_made_by: "Fait par",

    // Admin
    admin_title: "Tableau de bord",
    admin_visits: "Réservations visites",
    admin_accommodations: "Réservations hébergement",
    admin_weddings: "Contacts mariage",
    admin_date: "Date",
    admin_name: "Nom",
    admin_email: "E-mail",
    admin_phone: "Téléphone",
    admin_status: "Statut",
    admin_guests: "Personnes",
    admin_type: "Type",
    admin_message: "Message",
    admin_pending: "En attente",
    admin_confirmed: "Confirmé",
    admin_cancelled: "Annulé",
    admin_new: "Nouveau",
    admin_contacted: "Contacté",
    admin_quoted: "Devis envoyé",
    admin_closed: "Clôturé",
    admin_no_data: "Aucune donnée pour le moment.",

    // RGPD
    cookie_title: "Nous utilisons des cookies",
    cookie_text: "Ce site utilise des cookies pour améliorer votre expérience. Vous pouvez accepter tous les cookies ou refuser les cookies optionnels.",
    cookie_accept: "Tout accepter",
    cookie_refuse: "Refuser les optionnels",
    cookie_more: "En savoir plus",
    cookie_essential: "Cookies essentiels",
    cookie_analytics: "Cookies analytiques",

    // Portal
    portal_chateau_label: "Patrimoine & Culture",
    portal_chateau_title: "Le Château",
    portal_chateau_desc: "Visites commentées, histoire, architecture néo-palladienne",
    portal_sejours_label: "Hébergement & Événements",
    portal_sejours_title: "Séjours & Réceptions",
    portal_sejours_desc: "Chambres d'hôtes, gîtes, mariages et réceptions",
    portal_enter: "Entrer",
    portal_scroll: "Défiler pour explorer",

    // Common
    loading: "Chargement…",
    sending: "Envoi en cours…",
    error: "Une erreur est survenue.",
    required_field: "Ce champ est obligatoire.",
    invalid_email: "Adresse e-mail invalide.",
    close: "Fermer",
    back: "Retour",
    opening_popup_eyebrow: "Château de Syam, Jura",
    opening_popup_title: "Ouvert {periode}",
    opening_popup_details: "La Villa Palladienne vous accueille {jours_heures}.{fermes_phrase}",
    opening_popup_cta: "Organiser votre visite",
    opening_popup_close: "Fermer le message d’ouverture",
    opening_popup_image_alt: "Vue extérieure de la Villa Palladienne du Château de Syam",
    winter_popup_title: "Pause hivernale",
    winter_popup_text_1: "Comme chaque année, nous sommes actuellement fermés pour une pause hivernale.",
    winter_popup_text_2: "Réouverture officielle le 18 avril 2027.",
    winter_popup_text_3: "Merci pour votre incroyable soutien, on se retrouve très vite !",
    winter_popup_cta: "Découvrir le site",
    // Drawer réservation
    drawer_title: "Acheter vos billets en ligne",
    drawer_subtitle: "Votre billet inclut un audioguide. Vous êtes accueilli à votre arrivée {entre_heures}, puis vous démarrez votre visite.",
    drawer_tickets: "Billets",
    drawer_adult: "Adulte",
    drawer_adult_note: "14 ans et plus",
    drawer_child: "Enfant",
    drawer_child_note: "Moins de 14 ans",
    drawer_free: "Gratuit",
    drawer_free_note: "Enfants accompagnés",
    drawer_ticket_valid: "Billet valable 1 an",
    drawer_ticket_valid_desc: "Votre billet est valable <strong>1 an</strong> à partir de la date d'achat. Présentez-le à l'entrée (email ou téléphone).",
    drawer_ticket_hours: "Ouvert {jours_heures_court} · {Periode}{fermes_court_paren}",
    drawer_contact: "Vos coordonnées",
    drawer_firstname: "Prénom",
    drawer_lastname: "Nom",
    drawer_email: "Email",
    drawer_summary: "Récapitulatif",
    drawer_adult_plural: "adulte",
    drawer_adult_plural_s: "adultes",
    drawer_child_plural: "enfant",
    drawer_child_plural_s: "enfants",
    drawer_free_plural: "gratuit",
    drawer_free_plural_s: "gratuits",
    drawer_total: "Total",
    drawer_pay: "Payer",
    drawer_pay_online: "en ligne",
    drawer_redirecting: "Redirection vers le paiement…",
    drawer_unavailable: "Paiement indisponible",
    drawer_secure: "Paiement sécurisé via Stripe · Aucune donnée bancaire stockée",
    drawer_stripe_error: "Paiement temporairement indisponible. Contactez-nous au 03 84 51 64 14.",
    drawer_min_ticket: "Minimum 1 billet requis.",
    drawer_per_person: "/ personne",
    heritage_popup_eyebrow: "Journées du Patrimoine",
    heritage_popup_title: "19 & 20 septembre 2026",
    heritage_popup_details: "Visites libres avec audioguide · de 10 h à 18 h · aucune réservation nécessaire.",
    heritage_popup_prices: "Adulte : 10 € · Enfant de moins de 14 ans : 5 €",
    heritage_popup_cta: "Acheter mes billets",
    heritage_popup_image_alt: "Affiche des Journées du Patrimoine 2026 au Château de Syam",
    drawer_ticket_type: "Votre visite",
    standard_ticket_option: "Visite audio-guidée classique",
    heritage_ticket_option: "Journées du Patrimoine · 19 & 20 septembre",
    heritage_ticket_valid: "Billet valable les 19 & 20 septembre 2026",
    heritage_ticket_details: "Votre billet est valable pour l’une des deux journées. Présentez-le à l’entrée.",
    heritage_ticket_hours: "10 h–18 h · visites libres avec audioguide",
    heritage_ticket_closed: "La billetterie des Journées du Patrimoine est désormais fermée.",
    heritage_ticket_confirmation_type: "Journées du Patrimoine 2026",
    heritage_ticket_confirmation_date: "19 & 20 septembre 2026 · 10 h–18 h",
    heritage_ticket_confirmation_info: "Votre billet est valable les 19 et 20 septembre 2026, de 10 h à 18 h. Présentez-le à l’entrée du château.",
    heritage_ticket_valid_label: "Valable les",
    // --- Mini-sites communs ---
    ms_seo_title_visiter: "Visiter le Château de Syam | Villa Palladienne · Jura",
    ms_seo_desc_visiter: "Visitez le Château de Syam, seule villa néo-palladienne de France. Visite guidée, papiers peints panoramiques, mobilier Empire. Ouvert {periode}.",
    ms_hero_surtitle_visiter: "Château de Syam · Jura",
    ms_hero_title_visiter: "Visiter",
    ms_hero_subtitle_visiter: "Découvrez la seule villa néo-palladienne de France, classée Monument Historique",
    ms_hero_cta_visit: "Billetterie",
    ms_hero_cta_discover: "Découvrir",
    ms_hero_cta_devis: "Réserver",
    ms_nav_accueil: "Accueil",
    ms_nav_histoire: "Histoire",
    ms_nav_galerie: "Galerie",
    ms_nav_infos: "Infos pratiques",
    ms_nav_contact: "Contact",
    ms_nav_contact_devis: "Contact & Devis",
    ms_nav_reserver: "Réserver",
    // Visiter - infos
    ms_infos_hero_title: "Informations pratiques",
    ms_infos_horaires_titre: "Horaires",
    ms_infos_tarifs_titre: "Tarifs",
    ms_infos_tarifs_note: "Visite audio-guidée incluse dans le prix d'entrée. Tarif réduit : 6–18 ans, étudiants, demandeurs d'emploi, personnes handicapées. Durée approximative : 1h30.",
    ms_infos_groupe_note: "Tarifs dégressifs dès 10 personnes, visites privées et formules sur mesure pour groupes, scolaires et associations.",
    ms_infos_acces_titre: "Géolocalisation",
    ms_infos_services_titre: "Sur place",
    ms_infos_cta_titre: "Préparez votre visite",
    ms_infos_cta_btn_1: "Découvrir",
    // Visiter - histoire
    ms_histoire_hero_surtitle: "Patrimoine · Château de Syam",
    ms_histoire_hero_title: "Histoire",
    ms_histoire_hero_subtitle: "Deux siècles d'histoire dans un monument unique en France",
    ms_histoire_intro_label: "Villa Palladienne",
    ms_histoire_intro_title: "Un chef-d'œuvre néo-palladien",
    ms_histoire_chrono_label: "Chronologie",
    ms_histoire_chrono_title: "Deux siècles d'histoire",
    ms_histoire_tresors_label: "Patrimoine",
    ms_histoire_tresors_title: "Les trésors du château",
    ms_histoire_cta_label: "Venez découvrir",
    ms_histoire_cta_title: "Visitez le château",
    ms_histoire_cta_btn: "Informations pratiques",
    ms_histoire_cta_back: "← Retour",
    ms_histoire_intro_p1: "Le Château de Syam est l'un des rares exemples d'architecture néo-palladienne en France. Inspiré des villas de l'architecte vénitien Andrea Palladio (1508–1580), il se distingue par sa façade à colonnes ioniques, son plan parfaitement symétrique et ses proportions harmonieuses.",
    ms_histoire_intro_p2: "Construit entre 1818 et 1825 par Joseph-Désiré Jobez, maître de forges, le château est demeuré dans la même famille depuis plus de deux siècles. Classé Monument Historique, il conserve ses décors intérieurs d'origine dans un état de préservation exceptionnel.",
    ms_histoire_arch_label: "Architecture",
    ms_histoire_cta_subtitle: "Partez à la découverte de deux siècles d'histoire lors d'une visite audio-guidée commentée par nos guides passionnés.",
    // Paiement
    ms_paiement_hero_surtitle: "Château de Syam · Jura",
    ms_paiement_hero_title: "Réserver une visite audio-guidée",
    ms_paiement_hero_subtitle: "Paiement sécurisé par carte bancaire · Confirmation immédiate par email",
    ms_paiement_stripe_unavailable: "Paiement en ligne temporairement indisponible. Les clés Stripe ne sont pas encore configurées. Veuillez contacter le château directement au 03 84 51 64 14 pour réserver votre visite.",
    ms_paiement_img_alt: "Façade du Château de Syam",
    ms_paiement_chateau_name: "Château de Syam",
    ms_paiement_chateau_desc: "Monument historique classé · Villa Palladienne · Jura · Édifié en 1818",
    ms_paiement_infos_pratiques: "📍 225 Chemin de Benaisy, 39300 Syam · 🕑 Visites {jours_heures_court} · 📅 {Periode} · 📞 03 84 51 64 14",
    ms_paiement_error_session: "Impossible de créer la session de paiement.",
    ms_paiement_error_generic: "Erreur lors de la création du paiement.",
    ms_paiement_tickets_title: "Sélection des billets",
    ms_paiement_adults_label: "Adultes",
    ms_paiement_children_label: "Enfants (–14 ans)",
    ms_paiement_date_title: "Date de visite",
    ms_paiement_date_label: "Date souhaitée *",
    ms_paiement_date_note: "Visites commentées {jours_heures}, {periode}. Durée : environ 1h30.",
    ms_paiement_coords_title: "Vos coordonnées",
    ms_paiement_firstname: "Prénom *",
    ms_paiement_lastname: "Nom *",
    ms_paiement_email: "Email *",
    ms_paiement_phone: "Téléphone",
    ms_paiement_btn_loading: "Redirection vers le paiement…",
    ms_paiement_btn_unavailable: "Paiement indisponible",
    ms_paiement_btn_pay: "Procéder au paiement",
    ms_paiement_secure: "🔒 Paiement 100% sécurisé via Stripe · Aucune donnée bancaire stockée",
    ms_paiement_recap_label: "Récapitulatif",
    ms_paiement_recap_title: "Visite audio-guidée commentée",
    ms_paiement_recap_subtitle: "Château de Syam · Jura",
    ms_paiement_recap_date: "Date",
    ms_paiement_recap_visitors: "Visiteurs",
    ms_paiement_recap_total: "Total",
    ms_paiement_adult_x: "adulte",
    ms_paiement_adults_x: "adultes",
    ms_paiement_child_x: "enfant",
    ms_paiement_children_x: "enfants",
    ms_paiement_tarifs_label: "Tarifs",
    ms_paiement_tarif_adulte: "Adulte : 12 €",
    ms_paiement_tarif_enfant: "Enfant (–14 ans) : 5 €",
    // Confirmation
    ms_confirm_payment_label: "Paiement confirmé",
    ms_confirm_title: "Votre billet est confirmé",
    ms_confirm_email_sent: "Un email avec votre billet PDF a été envoyé à",
    ms_confirm_email_fallback: "Votre billet a été envoyé par email",
    ms_confirm_ref_label: "Référence",
    ms_confirm_total_label: "Total payé",
    ms_confirm_dl_title: "Télécharger votre billet",
    ms_confirm_dl_subtitle: "Format PDF — à présenter à l'entrée du château",
    ms_confirm_dl_btn: "Télécharger PDF",
    ms_confirm_dl_loading: "Génération…",
    ms_confirm_email_pending: "Envoi de votre billet en cours…",
    ms_confirm_email_already: "Votre billet a déjà été envoyé à",
    ms_confirm_email_check: "Vérifiez vos spams si besoin.",
    ms_confirm_email_error: "L'envoi de l'email a rencontré une erreur. Vous pouvez télécharger votre billet ci-dessus et le présenter à l'entrée.",
    ms_confirm_infos_label: "Informations pratiques",
    ms_confirm_infos_text: "Les visites guidées commentées ont lieu {jours_heures}, {periode}. Présentez votre billet à l'entrée du château (version papier ou sur téléphone).",
    ms_confirm_back_site: "Retour au site",
    ms_confirm_back_home: "Accueil du château",
    ms_confirm_loading: "Chargement de votre réservation…",
    ms_confirm_no_order: "Aucune réservation trouvée.",
    ms_confirm_visiteur_label: "Visiteur",
    ms_confirm_valid_label: "Valable jusqu'au",
    ms_confirm_billets_label: "Billets",
    ms_confirm_billets_pl: "billets",
    ms_confirm_billet_sg: "billet",
    ms_confirm_ticket_header: "Château de Syam · Billet d'entrée",
    ms_confirm_ticket_type: "Visite audio-guidée",
    ms_visiter_horaires_court: "{jours_heures_court}{fermes_court_paren}",
    // Mariage
    ms_mariage_seo_title: "Mariage au Château de Syam | Salle de réception Jura",
    ms_mariage_seo_desc: "Mariage au château néo-palladien classé du Jura : salle 170 m², parc 10 ha, jusqu'à 150 convives. Cadre d'exception en Bourgogne-Franche-Comté.",
    ms_mariage_hero_surtitle: "Mariages & Réceptions · Château de Syam",
    ms_mariage_hero_title: "Se Marier au Château",
    ms_mariage_hero_subtitle: "Un cadre d'exception pour le plus beau jour de votre vie",
    ms_mariage_atouts_surtitle: "Le cadre idéal",
    ms_mariage_atouts_title: "Un château pour votre mariage",
    ms_mariage_nav_label: "Mariage",
    ms_mariage_cta_devis: "Demander un devis",
    ms_mariage_cta_discover: "Découvrir",
    ms_mariage_cta_surtitle: "Votre grand jour",
    ms_mariage_cta_note: "Contactez-nous pour vérifier la disponibilité de votre date et recevoir notre brochure mariage.",
    ms_mariage_cta_btn: "Contactez-nous",
    ms_mariage_seo_label: "Localisation",
    ms_mariage_location_title: "Se marier dans un château en Bourgogne-Franche-Comté",
    // Événement
    ms_event_seo_title: "Événements d'entreprise au Château de Syam | Séminaires Jura",
    ms_event_seo_desc: "Séminaires, galas et événements d'entreprise au Château de Syam. Espaces modulables jusqu'à 200 personnes, cadre historique classé. Jura.",
    ms_event_hero_surtitle: "Événements & Séminaires · Château de Syam",
    ms_event_hero_title: "Événements d'Exception",
    ms_event_hero_subtitle: "Séminaires, lancements de produits, galas et événements privés dans un cadre unique",
    ms_event_espaces_title: "Des espaces pour chaque événement",
    ms_event_espaces_label: "Espaces",
    ms_event_cta_label: "Devis personnalisé",
    ms_event_cta_title: "Organisez votre événement",
    ms_event_cta_text: "Chaque événement est unique. Contactez-nous pour un devis sur mesure adapté à vos besoins.",
    ms_event_cta_btn: "Demander un devis",
    ms_event_nav_label: "Événement",
    ms_event_nav_espaces: "Nos espaces",
    // Groupe
    ms_groupe_seo_title: "Visites de groupe au Château de Syam | Jura",
    ms_groupe_seo_desc: "Visites de groupe au Château de Syam : groupes touristiques, scolaires, familles. Tarifs dégressifs dès 10 personnes. Monument Historique, Jura.",
    ms_groupe_hero_surtitle: "Château de Syam · Jura",
    ms_groupe_hero_title: "Groupes",
    ms_groupe_hero_subtitle: "Visites guidées, séjours et journées découvertes\npour groupes, familles et associations",
    ms_groupe_formules_surtitle: "Nos formules",
    ms_groupe_formules_title: "Une expérience sur mesure",
    ms_groupe_form_title: "Organiser votre visite de groupe",
    ms_groupe_pourquoi_label: "Pourquoi nous choisir",
    ms_groupe_pourquoi_title: "Logistique simplifiée, localisation stratégique",
    ms_groupe_pourquoi_text: "Situé à 4 km de Champagnole, au cœur du Jura, le Château de Syam est facilement accessible depuis Besançon (1h), Dijon (1h), Lausanne (1h) et Genève (1h). Parking cars, accès de plain-pied, guide disponible.",
    grp_park_description: "Découvrez notre parc romantique.",
    grp_options_description: "Accueil café, cocktails apéritifs, dégustation de crémants du Jura, thé time, des formules pour enrichir votre journée de groupe — 8 € par personne.",
    ms_groupe_nav_label: "Groupe",
    ms_groupe_nav_contact: "Contact",
    ms_groupe_cta_contact: "Contact",
    ms_groupe_form_surtitle: "Demande de réservation",
    ms_groupe_form_firstname: "Prénom *",
    ms_groupe_form_lastname: "Nom *",
    ms_groupe_form_email: "Email *",
    ms_groupe_form_phone: "Téléphone",
    ms_groupe_form_size: "Taille du groupe",
    ms_groupe_form_size_placeholder: "Ex : 25 personnes",
    ms_groupe_form_date: "Date souhaitée",
    ms_groupe_form_formule: "Formule souhaitée",
    ms_groupe_form_formule_placeholder: "Choisir une formule",
    ms_groupe_form_message: "Message",
    ms_groupe_form_message_placeholder: "Précisez votre projet, vos attentes...",
    ms_groupe_form_submit: "Envoyer ma demande",
    ms_groupe_form_submit_loading: "Envoi en cours...",
    ms_groupe_tarif_adulte: "Tarif adulte",
    ms_groupe_tarif_chauffeur: "Chauffeur",
    ms_groupe_tarif_accompagnateur: "1 accompagnateur",
    ms_groupe_tarif_horaires: "Horaires groupes",
    ms_groupe_tarif_parking: "Parking car",
    ms_groupe_tarif_adulte_val: "12 € / personne",
    ms_groupe_tarif_gratuit: "Gratuit",
    ms_groupe_tarif_horaires_val: "09h00 – 18h00 sur réservation",
    ms_groupe_tarif_parking_val: "Facile d’accès",
    ms_groupe_nos_formules: "Nos formules",
    // Offrir
    ms_offrir_seo_title: "Offrir le Château de Syam | Formules cadeaux Jura",
    ms_offrir_seo_desc: "Offrez une expérience au Château de Syam : visites, séjours, formules cadeaux. Idée cadeau originale dans une demeure néo-palladienne classée. Jura.",
    ms_offrir_hero_surtitle: "Formules cadeaux · Château de Syam",
    ms_offrir_hero_title: "Offrir le Château",
    ms_offrir_hero_subtitle: "Offrez une expérience unique dans un monument historique du Jura",
    ms_offrir_offres_label: "Nos offres",
    ms_offrir_offres_title: "Des expériences à offrir",
    ms_offrir_cta_label: "Formule cadeau personnalisée",
    ms_offrir_cta_title: "Un cadeau sur mesure",
    ms_offrir_cta_text: "Vous souhaitez une offre personnalisée ? Contactez-nous pour créer une formule cadeau unique.",
    ms_offrir_cta_btn: "Commander",
    ms_offrir_commander: "Commander",
    ms_offrir_paiement_hero_surtitle: "Château de Syam · Jura",
    ms_offrir_paiement_hero_subtitle: "Paiement sécurisé par carte bancaire",
    ms_offrir_paiement_hero_subtitle_email: "Formule cadeau envoyée par e-mail selon votre choix",
    ms_offrir_paiement_hero_subtitle_post: "Formule cadeau livrée par la poste",
    ms_offrir_paiement_section1_billets: "1. Choisir les billets",
    ms_offrir_paiement_adult_label: "Adulte (14 ans et +)",
    ms_offrir_paiement_child_label: "Enfant (6–13 ans)",
    ms_offrir_paiement_child_note: "Moins de 6 ans : gratuit",
    ms_offrir_paiement_min_billet: "Veuillez sélectionner au moins 1 billet.",
    ms_offrir_paiement_section1_formule: "1. Votre formule cadeau",
    ms_offrir_paiement_classique_desc: "1 nuit pour 2 · 2 petits-déjeuners · 2 visites audio-guidées incluses",
    ms_offrir_paiement_prestige_desc: "1 nuit pour 2 · Dîner romantique · Petit-déjeuner · Visite incluse",
    ms_offrir_paiement_beneficiaire_note: "Le bénéficiaire recevra une invitation avec un code pour réserver sa nuit en ligne (ou par téléphone).",
    ms_offrir_paiement_section2: "2. Vos coordonnées",
    ms_offrir_paiement_buyer_firstname: "Prénom *",
    ms_offrir_paiement_buyer_lastname: "Nom *",
    ms_offrir_paiement_buyer_email: "Email *",
    ms_offrir_paiement_buyer_phone: "Téléphone",
    ms_offrir_paiement_section3: "3. Destinataire du cadeau",
    ms_offrir_paiement_recipient_note: "Renseignez les coordonnées du destinataire de votre formule cadeau.",
    ms_offrir_paiement_recipient_firstname: "Prénom du destinataire *",
    ms_offrir_paiement_recipient_lastname: "Nom du destinataire",
    ms_offrir_paiement_recipient_email: "Email du destinataire",
    ms_offrir_paiement_send_direct: "Envoyer la formule cadeau directement au destinataire",
    ms_offrir_paiement_delivery_buyer: "Si cette case n’est pas cochée, le PDF sera envoyé à votre adresse email après paiement.",
    ms_offrir_paiement_shipping_label: "Adresse de livraison de la formule cadeau",
    ms_offrir_paiement_shipping_note: "La formule cadeau sera envoyée par courrier à cette adresse.",
    ms_offrir_paiement_shipping_address: "Adresse *",
    ms_offrir_paiement_shipping_zip: "Code postal *",
    ms_offrir_paiement_shipping_city: "Ville *",
    ms_offrir_paiement_shipping_country: "Pays",
    ms_offrir_paiement_message_label: "Message personnalisé (optionnel)",
    ms_offrir_paiement_recap_title: "Récapitulatif",
    ms_offrir_paiement_adult_x: "Adulte",
    ms_offrir_paiement_child_x: "Enfant",
    ms_offrir_paiement_no_billet: "Aucun billet sélectionné",
    ms_offrir_paiement_total: "Total",
    ms_offrir_paiement_cadeau_note: "Les formules cadeaux sont le plus souvent livrées par e-mail. Un envoi par la poste peut être demandé. Valable 1 an à compter de la date d'achat.",
    ms_offrir_paiement_btn_pay: "Payer",
    ms_offrir_paiement_btn_loading: "Redirection...",
    ms_offrir_paiement_secure: "Paiement sécurisé par Stripe",
    ms_offrir_paiement_error_session: "Impossible de créer la session de paiement.",
    ms_offrir_paiement_error_generic: "Erreur lors de la création du paiement.",
    ms_offrir_paiement_error_email: "Veuillez renseigner votre adresse email.",
    ms_offrir_paiement_error_recipient: "Veuillez renseigner l'adresse email du destinataire.",
    ms_offrir_paiement_error_shipping: "Veuillez renseigner l'adresse de livraison complète.",
    ms_offrir_formule_decouverte: "Formule Découverte",
    ms_offrir_formule_classique: "Formule Classique",
    ms_offrir_formule_prestige: "Formule Prestige",
    ms_offrir_nav_label: "Offrir",
    // Gîtes
    ms_gites_seo_title: "Gîtes au Château de Syam | Location Jura",
    ms_gites_seo_desc: "Gîtes César et Rosalie au Château de Syam : location indépendante pour familles et groupes dans un domaine néo-palladien classé. Jura.",
    ms_gites_hero_surtitle: "Gîtes · Château de Syam",
    ms_gites_hero_title: "Nos Gîtes",
    ms_gites_hero_subtitle: "Séjournez en toute indépendance dans le domaine du château",
    ms_gites_hebergement_label: "Hébergement",
    ms_gites_deux_gites: "Deux gîtes de caractère",
    ms_gites_reserver_btn: "Réserver",
    ms_gites_voir_btn: "Voir les gîtes",
    ms_gites_reserver_online: "Réserver en ligne",
    ms_gites_infos_label: "Informations",
    ms_gites_infos_checkin: "Disponibles {periode}",
    ms_gites_infos_btn_infos: "Informations pratiques",
    ms_gites_infos_btn_contact: "Nous contacter",
    ms_gites_nuit: "/ nuit",
    ms_gites_inclus_terrasse: "Gîtes en rez-de-jardin avec terrasse ombragée privée",
    ms_gites_inclus_parc: "Parc arborié de 10 hectares à votre disposition",
    ms_gites_inclus_jardin: "Mobilier de jardin et barbecue inclus",
    ms_gites_inclus_parking: "Parking privé gratuit sur place",
    ms_gites_inclus_adresse: "225 Chemin de Benaisy, 39300 Syam — 4 km de Champagnole",
    ms_gites_inclus_tel: "Réservation : 03 84 51 64 14 — 06 87 54 14 57",
    ms_gites_adresse: "Château de Syam · 39300 Syam, Jura",
    ms_gites_nav_label: "Gîtes du Château",
    ms_gites_nav_infos: "Infos pratiques",
    // Dormir (chambres)
    ms_dormir_nav_label: "Dormir au Château",
    ms_dormir_nav_chambres: "Nos chambres",
    ms_dormir_nav_infos: "Infos pratiques",
    ms_dormir_hero_surtitle: "Chambres d'hôtes · Château de Syam",
    ms_dormir_hero_title: "Dormir au Château",
    ms_dormir_hero_subtitle: "Séjournez dans un monument historique classé au cœur du Jura",
    ms_dormir_chambres_label: "Hébergement",
    ms_dormir_chambres_title: "Nos chambres d'hôtes",
    ms_dormir_reserver_btn: "Réserver",
    ms_dormir_voir_btn: "Voir les chambres",
    ms_dormir_reserver_online: "Réserver en ligne",
    ms_dormir_nuit: "/ nuit",
    ms_dormir_detail_pdj: "2 petits-déjeuners gourmands inclus",
    ms_dormir_detail_visite: "2 visites du château incluses",
    ms_dormir_detail_sdb: "Salle de bain privée",
    ms_dormir_note_sejour: "Séjour du Dimanche au Vendredi uniquement (pas de nuit du samedi). Taxe de séjour 1 €/adulte/nuit.",
    ms_gites_note_sejour: "Séjour du Dimanche au Vendredi uniquement (pas de nuit du samedi). Taxe de séjour 1 €/adulte/nuit.",
    // Formulaire contact commun
    ms_form_firstname: "Prénom *",
    ms_form_lastname: "Nom *",
    ms_form_email: "Email *",
    ms_form_phone: "Téléphone",
    ms_form_message: "Message",
    ms_form_submit: "Envoyer le message",
    ms_form_submit_loading: "Envoi...",
    ms_form_success: "Message envoyé",
    ms_form_success_text: "Nous vous répondrons dans les 48 heures.",
    ms_form_contact_title: "Contact",
    ms_form_infos_title: "Coordonnées",
    ms_form_reservation_label: "Réservation en ligne",
    ms_form_reservation_btn: "Réserver en ligne",

    /* ── Gîte César ── */
    gite_cesar_back: "Retour aux gîtes",
    gite_cesar_surtitle: "Gîte · Château de Syam",
    gite_cesar_title: "Gîte César",
    gite_cesar_desc_label: "Description",
    gite_cesar_desc_text: "Appartement duplex pour 5 personnes maximum, au rez-de-jardin du domaine. 2 chambres, cuisine entièrement équipée, séjour lumineux, salle de bain et WC séparés. Terrasse ombragée avec mobilier de jardin et barbecue.",
    gite_cesar_feat_1: "Appartement duplex indépendant",
    gite_cesar_feat_2: "2 chambres — max. 5 personnes",
    gite_cesar_feat_3: "Cuisine entièrement équipée",
    gite_cesar_feat_4: "Terrasse ombragée avec barbecue",
    gite_cesar_feat_5: "Linge de maison et draps inclus",
    gite_cesar_feat_6: "Parking privé gratuit",
    gite_cesar_feat_7: "Parc de 10 hectares",
    gite_cesar_feat_8: "Séjour du dimanche au vendredi uniquement",
    gite_cesar_type_val: "Appartement duplex",
    gite_cesar_capacite_val: "Max. 5 personnes",
    gite_cesar_chambres_val: "2 chambres",
    gite_cesar_calendrier_title: "Calendrier du gîte César",
    gite_cesar_reserver_title: "Réserver le gîte César",

    /* ── Gîte Rosalie ── */
    gite_rosalie_title: "Gîte Rosalie",
    gite_rosalie_desc_text: "Grand appartement duplex pour 9 personnes maximum, idéal pour les familles et groupes d'amis. 4 chambres, cuisine entièrement équipée, séjour spacieux, 2 salles de bain, 2 WC. Terrasse ombragée avec mobilier de jardin et barbecue.",
    gite_rosalie_feat_1: "Grand appartement duplex indépendant",
    gite_rosalie_feat_2: "4 chambres — max. 9 personnes",
    gite_rosalie_feat_3: "2 salles de bain — 2 WC",
    gite_rosalie_feat_4: "Cuisine entièrement équipée",
    gite_rosalie_feat_5: "Terrasse ombragée avec barbecue",
    gite_rosalie_feat_6: "Linge de maison et draps inclus",
    gite_rosalie_feat_7: "Parking privé gratuit",
    gite_rosalie_feat_8: "Parc de 10 hectares",
    gite_rosalie_feat_9: "Séjour du dimanche au vendredi uniquement",
    gite_rosalie_type_val: "Grand appartement duplex",
    gite_rosalie_capacite_val: "Max. 9 personnes",
    gite_rosalie_chambres_val: "4 chambres",
    gite_rosalie_salles_bain_val: "2 salles de bain",
    gite_rosalie_calendrier_title: "Calendrier du gîte Rosalie",
    gite_rosalie_reserver_title: "Réserver le gîte Rosalie",

    /* ── Infos pratiques communes gîtes ── */
    gite_infos_pratiques_label: "Informations pratiques",
    gite_infos_type: "Type",
    gite_infos_capacite: "Capacité",
    gite_infos_chambres: "Chambres",
    gite_infos_salles_bain: "Salles de bain",
    gite_infos_sejour_min: "Séjour minimum",
    gite_infos_sejour_min_val: "2 nuits",
    gite_infos_dispo: "Disponibilité",
    gite_infos_dispo_val: "Dimanche au vendredi",
    gite_infos_saison: "Saison",
    gite_infos_saison_val: "{Periode}",
    gite_infos_menage: "Forfait ménage",
    gite_infos_menage_val: "50 € en sus",
    gite_infos_taxe: "Taxe de séjour",
    gite_infos_taxe_val: "1 €/adulte/nuit",
    gite_disponibilites_label: "Disponibilités",
    gite_voir_tous: "Voir tous les gîtes",

    /* ── Page contact Groupe ── */
    groupe_contact_title: "Contact & Réservation Groupes",
    groupe_contact_subtitle: "Contact — Groupes",
    groupe_contact_intro: "Clubs, associations, comités d'entreprise, groupes scolaires... Décrivez votre projet et la taille de votre groupe, nous vous répondons sous 48h avec une proposition adaptée.",
    groupe_contact_infos_groupes_label: "Groupes",
    groupe_contact_infos_groupes_val: "À partir de 10 personnes\nTarifs dégressifs disponibles\nChauffeur & accompagnateur gratuits",
    groupe_contact_infos_adresse_label: "Adresse",

    /* ── MiniSiteLayout ── */
    layout_nav_home: "Accueil",
    layout_nav_gallery: "Galerie",
    layout_nav_contact: "Contact & Réservation",
    layout_back_home: "Accueil",
    layout_back_home_mobile: "← Retour à l'accueil",
    layout_close_menu: "Fermer le menu",
    layout_legal: "Mentions légales",
    layout_privacy: "Politique de confidentialité",
    layout_cgv: "CGV",

    /* ── BrochurePopup ── */
    brochure_label_visiter: "Brochure Visites",
    brochure_desc_visiter: "Découvrez l'histoire et l'architecture de la Villa Palladienne, monument historique unique en France.",
    brochure_label_dormir: "Brochure Chambres d'hôtes",
    brochure_desc_dormir: "Séjournez dans nos chambres d'exception au cœur du château, avec petit-déjeuner gourmand inclus.",
    brochure_label_roseraie: "Brochure Roseraie",
    brochure_desc_roseraie: "Découvrez notre jardin de roses d'exception, un écrin de nature et de beauté au Château de Syam.",
    brochure_label_gites: "Brochure Gîtes",
    brochure_desc_gites: "Vivez une expérience unique dans nos gîtes privatifs César et Rosalie, au cœur du domaine.",
    brochure_label_evenement: "Brochure Événements",
    brochure_desc_evenement: "Organisez votre séminaire, gala ou lancement de produit dans un cadre historique d'exception.",
    brochure_label_groupe: "Brochure Groupes",
    brochure_desc_groupe: "Visites guidées, séjours et réceptions pour groupes touristiques et familles dans un cadre unique.",
    brochure_label_mariage: "Brochure Mariage",
    brochure_desc_mariage: "Célébrez votre mariage dans l'un des plus beaux châteaux du Jura, avec un service sur mesure.",
    brochure_fallback_desc: "Recevez notre brochure complète et découvrez toutes nos prestations.",
    brochure_close: "Fermer",
    brochure_title: "Vous souhaitez recevoir notre brochure ?",
    brochure_placeholder_prenom: "Prénom *",
    brochure_placeholder_nom: "Nom *",
    brochure_placeholder_email: "Adresse email *",
    brochure_placeholder_phone: "Téléphone",
    brochure_cta: "Recevoir la brochure",
    brochure_privacy: "Vos données restent confidentielles et ne seront jamais partagées.",
    brochure_success_title: "Merci",
    brochure_success_email: "Votre brochure vous a été envoyée. Vérifiez vos courriers indésirables si nécessaire.",
    brochure_success_pdf: "Votre brochure s'est ouverte dans un nouvel onglet.",
    brochure_success_fallback: "Merci pour votre intérêt ! Nous reviendrons vers vous très prochainement.",
    brochure_success_close: "Fermer",

    /* ── SmoobuWidget ── */
    smoobu_reservation_label: "Réservation en ligne",
    smoobu_calendar_loading: "Chargement du calendrier…",
    smoobu_calendar_unavailable: "Le calendrier ne s’affiche pas ?",
    smoobu_calendar_contact: "Contactez-nous",
    smoobu_advantage_1: "Confirmation immédiate",
    smoobu_advantage_2: "Paiement sécurisé",
    smoobu_advantage_3: "Annulation flexible",
    smoobu_advantage_4: "Meilleur tarif garanti",
    smoobu_trust_note: "Paiement sécurisé · Données chiffrées · Réservation directe sans intermédiaire",
    booking_step_header: "Réservation",
    booking_arrival: "Arrivée",
    booking_departure: "Départ",
    booking_calculating: "Calcul du prix en cours…",
    booking_unavailable: "Ces dates ne sont pas disponibles. Veuillez sélectionner d'autres dates.",
    booking_continue: "Continuer →",
    booking_back: "← Retour",
    booking_guests_title: "Combien de voyageurs ?",
    booking_adults: "Adultes",
    booking_children: "Enfants (–12 ans)",
    booking_max_capacity: "Capacité maximale",
    booking_persons: "personnes",
    booking_form_title: "Vos coordonnées",
    booking_firstname: "Prénom *",
    booking_lastname: "Nom *",
    booking_email: "Email *",
    booking_phone: "Téléphone",
    booking_note: "Message (optionnel)",
    booking_summary: "Récapitulatif",
    booking_night: "nuit",
    booking_nights: "nuits",
    booking_adult: "adulte",
    booking_adults_pl: "adultes",
    booking_child: "enfant",
    booking_children_pl: "enfants",
    booking_sending: "Envoi en cours…",
    booking_confirm: "Confirmer la réservation",
    booking_success_title: "Demande envoyée !",
    booking_success_text: "Votre demande de réservation a bien été transmise. Vous recevrez une confirmation par email dans les plus brefs délais.",
    booking_reference: "Référence",
    booking_new_search: "Nouvelle recherche",
    booking_error_generic: "Une erreur est survenue. Veuillez réessayer.",
    booking_error_dates: "Veuillez sélectionner vos dates d'arrivée et de départ.",
    booking_error_unavailable: "Ces dates ne sont pas disponibles pour ce logement.",
    booking_error_capacity: "Ce logement accueille au maximum",
    booking_error_fields: "Veuillez remplir tous les champs obligatoires.",

    /* ── SmoobuBookingWidget ── */

    /* ── RelatedMiniSites ── */
    related_surtitle: "Château de Syam",
    related_title: "Découvrez aussi",
    related_cta: "Découvrir →",
    related_visiter_label: "Visite",
    related_visiter_desc: "Visite audio-guidée du Monument Historique",
    related_dormir_label: "Chambres",
    related_dormir_desc: "Chambres d'hôtes de charme",
    related_gites_label: "Gîtes",
    related_gites_desc: "Location de gîtes indépendants",
    related_mariage_label: "Mariage",
    related_mariage_desc: "Réceptions jusqu'à 150 convives",
    related_evenement_label: "Événements",
    related_evenement_desc: "Séminaires & événements d'entreprise",
    related_groupe_label: "Groupe",
    related_groupe_desc: "Visites de groupe sur mesure",
    related_offrir_label: "Offrir",
    related_offrir_desc: "Bons cadeaux & expériences",
    related_roseraie_label: "Roseraie",
    related_roseraie_desc: "200 variétés de roses historiques",

    not_found_eyebrow: "Château de Syam",
    not_found_title: "Cette page n’existe pas",
    not_found_text: "La page que vous recherchez a peut-être été déplacée. Retrouvez l’univers qui vous intéresse.",
    not_found_home: "Retour à l’accueil",
    not_found_sites_title: "Découvrir nos univers",
    not_found_link_visiter: "Visiter",
    not_found_link_dormir: "Chambres",
    not_found_link_mariage: "Mariage",
    not_found_link_gites: "Gîtes",

    faq_groupe_q1: "Quel est le tarif pour une visite de groupe ?",
    faq_groupe_a1: "La visite est proposée à 12 € par adulte et 5 € pour les enfants de moins de 14 ans. Nous proposons des visites guidées en français ainsi que des visites audio-guidées en français, anglais, allemand et néerlandais. Le chauffeur du car et un accompagnateur sont admis gratuitement. Nous proposons également des options d'accueil : accueil café, cocktails apéritifs, dégustation de crémants du Jura, thé time. Pour les groupes scolaires, contactez-nous pour un devis adapté.",
    faq_groupe_q2: "Faut-il réserver à l'avance pour un groupe ?",
    faq_groupe_a2: "Oui, la réservation est obligatoire pour les groupes. Nous accueillons les groupes sur réservation, y compris les jours où le château est fermé au public (lundi et mardi).",
    faq_groupe_q3: "Quelle est la taille minimale d'un groupe ?",
    faq_groupe_a3: "Nous accueillons les groupes à partir de 10 personnes. Pour les groupes plus petits, nous vous invitons à nous contacter afin de trouver une solution adaptée.",
    faq_groupe_q4: "Proposez-vous des visites en langues étrangères ?",
    faq_groupe_a4: "Oui, des visites audio-guidées sont disponibles en français, anglais, allemand et néerlandais. Des guides conférenciers peuvent également être organisés sur demande.",
    faq_groupe_q5: "Peut-on combiner la visite avec un repas ou une activité ?",
    faq_groupe_a5: "Absolument. Nous pouvons vous orienter vers des partenaires locaux pour le déjeuner, et proposer des activités complémentaires dans le Jura. Contactez-nous pour construire votre programme sur mesure.",
    faq_groupe_q6: "Y a-t-il un parking pour les cars ?",
    faq_groupe_a6: "Oui, le château dispose d'un espace de stationnement pour les autocars. L'accès est facilité depuis la D127, à 4 km de Champagnole.",
    faq_groupe_q7: "Le château est-il accessible aux personnes à mobilité réduite ?",
    faq_groupe_a7: "Le rez-de-chaussée du château est accessible. Certaines parties de l'édifice restent difficiles d'accès en raison du caractère historique du bâtiment. N'hésitez pas à nous contacter pour préparer votre visite.",
    faq_mariage_q1: "Où se situe le domaine et est-il facile d'accès depuis la Suisse et Lyon ?",
    faq_mariage_a1: "Le Château de Syam (la Villa Palladienne) bénéficie d'un emplacement stratégique dans le Jura (39), à proximité de Champagnole. C'est le lieu idéal pour un mariage destination : depuis la Suisse à seulement 1h15 de Genève et 1h30 de Lausanne, depuis la France à 1h de Besançon et Lons-le-Saunier, et environ 2h de Lyon et Dijon. Son architecture italienne unique en France en fait l'un des châteaux de mariage les plus recherchés de Bourgogne-Franche-Comté.",
    faq_mariage_q2: "Peut-on organiser une cérémonie laïque ou religieuse sur place ?",
    faq_mariage_a2: "Absolument. Cérémonie laïque : le parc romantique est l'écrin parfait. En cas de météo capricieuse, nos salons historiques offrent une solution de repli majestueuse. Cérémonie religieuse : une charmante église se trouve à quelques pas de la propriété, les offices étant célébrés par la paroisse de Champagnole.",
    faq_mariage_q3: "Quelles sont les capacités d'hébergement pour un mariage au château ?",
    faq_mariage_a3: "La propriété peut héberger plus de 60 personnes directement sur place : les Chambres d'Hôtes de la Villa Palladienne et les Gîtes du Fer à Cheval. C'est l'option favorite des mariés pour prolonger la fête et organiser un brunch chic le dimanche matin. Au-delà, de nombreuses solutions d'hôtellerie se trouvent à Syam et Champagnole.",
    faq_mariage_q4: "Les animaux sont-ils acceptés et peut-on tirer un feu d'artifice ?",
    faq_mariage_a4: "Amis à quatre pattes : nous laissons aux mariés la liberté de gérer la présence des animaux de compagnie de leurs invités. Environnement : située dans le cadre préservé du Parc Naturel du Haut-Jura, la villa ne peut autoriser les feux d'artifice ni les lanternes chinoises, afin de protéger la biodiversité locale.",
    faq_mariage_q5: "Le ménage est-il à la charge des mariés ?",
    faq_mariage_a5: "Pour que vous puissiez repartir l'esprit léger, vous n'avez pas à vous soucier du nettoyage. Un forfait ménage professionnel est systématiquement inclus dans votre devis de location.",
    chambre_label_description: "Description",
    chambre_label_infos_pratiques: "Informations pratiques",
    chambre_label_disponibilites: "Disponibilités",
    chambre_label_capacite: "Capacité",
    chambre_label_checkin: "Check-in",
    chambre_label_checkout: "Check-out",
    chambre_label_pdj: "Petit-déjeuner",
    chambre_label_adresse: "Adresse",
    chambre_label_contact: "Contact",
    chambre_label_etage: "Étage",
    chambre_label_lit: "Lit",
    chambre_label_style: "Style",
    chambre_label_exposition: "Exposition",
    chambre_label_vue: "Vue",
    chambre_label_sdb: "Salle de bain",
    chambre_label_type: "Type",
    chambre_val_2personnes: "2 personnes",
    chambre_val_checkin: "À partir de 18h00",
    chambre_val_checkout: "Avant 12h00",
    chambre_val_pdj: "Servi en chambre ou en terrasse",
    chambre_val_adresse: "225 Chemin de Benaisy, 39300 Syam",
    chambre_val_contact: "03 84 51 64 14",
    chambre_val_parking: "Parking privé gratuit",
    chambre_val_parc: "Parc de 10 hectares",
    chambre_val_pdj_inclus: "2 petits-déjeuners gourmands inclus",
    chambre_val_visites_incluses: "2 visites audio-guidées du château incluses",
    chambre_prix_nuit: "/ nuit · petit-déjeuner inclus",
    chambre_back_link: "Retour aux chambres",
    chambre_voir_toutes: "Voir toutes les chambres",
    chambre_surtitle: "Chambre d'hôtes · Château de Syam",
    chambre_amelie_calendrier_titre: "Calendrier de la chambre Amélie",
    chambre_amelie_reserver: "Réserver la chambre Amélie",
    chambre_amelie_etage: "2e étage",
    chambre_amelie_lit: "280 × 200 cm",
    chambre_amelie_sdb: "Douche à l'italienne — toilette séparée",
    chambre_amelie_cheminee: "Cheminée",
    chambre_helena_calendrier_titre: "Calendrier de la chambre Héléna",
    chambre_helena_reserver: "Réserver la chambre Héléna",
    chambre_helena_etage: "1er étage",
    chambre_helena_exposition: "Plein Est",
    chambre_helena_sdb: "Salle de bain privative — douche et baignoire",
    chambre_helena_vue: "Vue sur le Parc du Château",
    chambre_carnot_calendrier_titre: "Calendrier de la chambre Carnot",
    chambre_carnot_reserver: "Réserver la chambre Carnot",
    chambre_carnot_etage: "1er étage",
    chambre_carnot_style: "Charme Empire",
    chambre_carnot_exposition: "Plein Est",
    chambre_carnot_sdb: "Salle de bain privative — douche et baignoire",
    chambre_carnot_vue: "Vue sur le Parc du Château — Plein Est",
    chambre_josephine_calendrier_titre: "Calendrier de la chambre Joséphine",
    chambre_josephine_reserver: "Réserver la chambre Joséphine",
    chambre_josephine_etage: "1er étage",
    chambre_josephine_sdb: "Douche italienne + baignoire",
    chambre_josephine_sdb_detail: "Douche à l'italienne et baignoire",
    chambre_josephine_papier: "Papier peint panoramique oriental",
    chambre_eugenie_calendrier_titre: "Calendrier de la Suite Eugénie",
    chambre_eugenie_reserver: "Réserver la Suite Eugénie",
    chambre_eugenie_type: "Suite Empire",
    chambre_eugenie_surtitle: "Suite · Château de Syam",
    chambre_eugenie_etage: "2ème étage",
    chambre_eugenie_exposition: "Sud-Est",
    chambre_eugenie_baldaquin: "Lit à baldaquin 180 × 300 cm — soieries or et bleu",
    chambre_eugenie_salon: "Petit salon privatif",
    chambre_eugenie_vue: "Vue sur le Parc — Sud-Est",
    chambre_eugenie_sdb: "Salle de bain privative avec baignoire",
    visiter_confirmation_back: "Accueil",
    visiter_confirmation_galerie: "Galerie",
    visiter_confirmation_contact: "Contact",
    visiter_confirmation_dl_pdf: "Télécharger PDF",
    visiter_confirmation_dl_loading: "Génération…",
    visiter_confirmation_envoi: "Envoi de votre billet en cours…",
    visiter_paiement_erreur_session: "Impossible de créer la session de paiement.",
    visiter_paiement_erreur_general: "Erreur lors de la création du paiement.",
    visiter_paiement_redirect: "Redirection...",
    visiter_paiement_breadcrumb_visiter: "Visiter",
    visiter_paiement_breadcrumb_reserver: "Réserver",
    visiter_histoire_bibliotheque_titre: "La bibliothèque",
    visiter_histoire_bibliotheque_desc: "Au deuxième étage de la Villa, la bibliothèque présente ses boiseries d'origine, ses bustes et ses rayonnages anciens.",
    visiter_histoire_collection_livres_titre: "Notre collection de livres",
    visiter_histoire_collection_livres_desc: "Les ouvrages anciens de la Villa témoignent de son histoire familiale et intellectuelle.",
    visiter_histoire_parquets_titre: "Parquets marquetés",
    visiter_histoire_parquets_desc: "Les parquets en marqueterie de bois précieux sont d'origine. Chaque pièce présente un motif unique, témoignage du savoir-faire des artisans du XIXe siècle.",
    visiter_histoire_lustres_titre: "Lustres en cristal",
    visiter_histoire_lustres_desc: "Les lustres en cristal de Bohême illuminent les salons depuis deux siècles. Ils constituent l'un des ensembles les plus remarquables de la région.",
    visiter_histoire_mobilier_titre: "Mobilier Empire",
    visiter_histoire_mobilier_desc: "Le mobilier d'époque Empire et Restauration est conservé dans son état d'origine. Tables, commodes, lits à baldaquin... un voyage dans le temps.",
    visiter_histoire_decors_titre: "Décors insolites",
    visiter_histoire_decors_desc: "Papiers peints panoramiques, collections de curiosités, portraits de famille... Chaque recoin du château réserve une surprise.",
    offrir_formule_classique: "Formule Classique",
    offrir_formule_prestige: "Formule Prestige",
    offrir_formule_decouverte: "Formule Découverte",
    offrir_livraison_poste: "Bon cadeau livré par la poste",
    offrir_livraison_email: "Bon cadeau envoyé par email au destinataire",
    offrir_adulte_label: "Adulte (14 ans et +)",
    offrir_enfant_label: "Enfant (6–13 ans)",
    offrir_gratuit_label: "Moins de 6 ans : gratuit",
    offrir_nuit_pdj: "1 nuit pour 2 · 2 petits-déjeuners · 2 visites audio-guidées incluses",
    offrir_nuit_romantique: "1 nuit pour 2 · Dîner romantique · Petit-déjeuner · Visite incluse",
    offrir_erreur_session: "Impossible de créer la session de paiement.",
    offrir_erreur_general: "Erreur lors de la création du paiement.",
    offrir_erreur_billets: "Veuillez sélectionner au moins 1 billet.",
    offrir_erreur_email: "Veuillez renseigner votre adresse email.",
    offrir_erreur_email_dest: "Veuillez renseigner l'adresse email du destinataire.",
    offrir_erreur_adresse: "Veuillez renseigner l'adresse de livraison complète.",
    offrir_redirect: "Redirection...",
    offrir_confirmation_dl_pdf: "Télécharger PDF",
    offrir_confirmation_dl_loading: "Génération…",
    offrir_confirmation_erreur_dl: "Erreur téléchargement",
    offrir_confirmation_erreur_confirm: "Erreur de confirmation",
    offrir_confirmation_erreur_reseau: "Erreur reseau",
    ms_offrir_confirm_loading: "Vérification du paiement en cours…",
    ms_offrir_confirm_sent_label: "Formule cadeau envoyée",
    ms_offrir_confirm_merci: "Merci pour votre cadeau !",
    ms_offrir_confirm_email_sent: "Un email avec la formule cadeau PDF a été envoyé à",
    ms_offrir_confirm_processing: "Paiement en cours de traitement",
    ms_offrir_confirm_processing_text: "Si vous avez effectué le paiement, la formule cadeau sera envoyée dans quelques instants. Vous recevrez un email de confirmation.",
    ms_offrir_confirm_recap_title: "Récapitulatif de la formule cadeau",
    ms_offrir_confirm_ref: "Référence",
    ms_offrir_confirm_envoi: "Envoyé à",
    ms_offrir_confirm_validite: "Valable jusqu'au",
    ms_offrir_confirm_billets: "Billets",
    ms_offrir_confirm_adulte: "adulte",
    ms_offrir_confirm_adultes: "adultes",
    ms_offrir_confirm_enfant: "enfant",
    ms_offrir_confirm_enfants: "enfants",
    ms_offrir_confirm_montant: "Montant réglé",
    ms_offrir_confirm_dl_title: "Télécharger la formule cadeau",
    ms_offrir_confirm_dl_subtitle: "Format PDF — à offrir ou à imprimer",
    ms_offrir_confirm_email_note: "La formule cadeau PDF a été envoyée à",
    ms_offrir_confirm_email_spam: "Pensez à vérifier les spams si besoin.",
    ms_offrir_confirm_infos_label: "Informations pratiques",
    ms_offrir_confirm_infos_text: "Visites guidées : {jours_heures}, {periode}.{fermes_phrase} Le destinataire devra présenter son code billet à l'entrée du château.",
    ms_offrir_confirm_adresse: "Adresse : 225 Chemin de Benaisy, 39300 Syam — Tél. 03 84 51 64 14",
    ms_offrir_confirm_retour: "Retour au site",
    ms_offrir_confirm_autre: "Offrir un autre cadeau",
    roseraie_nav_accueil: "Accueil",
    roseraie_nav_galerie: "Galerie",
    roseraie_titre: "Roseraie",
    evenement_contact_capacite_label: "Capacité",
    evenement_contact_capacite_val: "Grande salle : 200 personnes\nParc : 500 personnes\nSalons : 30 personnes",
    evenement_contact_adresse_label: "Adresse",
    evenement_contact_adresse_val: "Chateau de Syam\n39300 Syam, Jura",
    mariage_contact_capacite_label: "Capacité",
    mariage_contact_capacite_val: "Jusqu'à 200 invités\nCérémonie laïque possible\nParc privatisé",
    mariage_contact_adresse_label: "Adresse",
    mariage_contact_adresse_val: "Chateau de Syam\n39300 Syam, Jura",
    dormir_contact_adresse_label: "Adresse",
    dormir_contact_adresse_val: "Chateau de Syam\n39300 Syam, Jura",
    dormir_contact_saison_label: "Saison",
    dormir_contact_saison_val: "{Periode_complete}\nPetit-déjeuner inclus\nVisite audio-guidée incluse",
    gites_contact_tarifs_label: "Tarifs",
    gites_contact_tarifs_val: "Gîte César : à partir de 150 €/nuit\nGîte Rosalie : à partir de 120 €/nuit\nSéjour minimum : 2 nuits",
    gites_contact_dispo_label: "Disponibilites",
    gites_contact_dispo_val: "Consultez le calendrier via notre module de réservation",

    ms_galerie_title: "Galerie",
    ms_galerie_subtitle: "Château de Syam",
    ms_faq_title: "Foire aux questions",
    ms_faq_surtitle: "FAQ",
    ms_visiter_decouverte_surtitle: "Découverte",
    ms_visiter_decouverte_title: "Découvrez la Villa Palladienne :",
    ms_visiter_decouverte_title_accent: "Un joyau italien au cœur du Jura",
    ms_visiter_decouverte_text: "Vous cherchez que faire dans le Jura pour une escapade culturelle inoubliable ? Entre les célèbres Salines Royales d'Arc-et-Senans et l'impressionnant Fort des Rousses, faites escale à la Villa Palladienne de Syam. Ce monument historique unique en France vous ouvre ses portes pour une visite audio-guidée fascinante, mêlant architecture vénitienne et secrets des Maîtres de Forges. Idéalement située près des Cascades du Hérisson et des Pertes de l'Ain, la Villa Palladienne est une sortie incontournable pour tous les amoureux de patrimoine et de nature en Bourgogne-Franche-Comté.",
    ms_visiter_faq_q1: "Quel monument voir absolument dans le Jura ?",
    ms_visiter_faq_a1: "Le Château de Syam (la célèbre Villa Palladienne) est une étape incontournable. Unique en France par son architecture néoclassique inspirée de l'Italie, ce site classé Monument Historique émerveille par sa rotonde spectaculaire et son décor d'époque parfaitement conservé. C'est la sortie culturelle phare près de Champagnole et du Jura.",
    ms_visiter_faq_q2: "Que faire dans le Jura après la visite des Salines Royales d'Arc-et-Senans ?",
    ms_visiter_faq_a2: "Le Château de Syam est le complément architectural idéal aux Salines Royales d'Arc-et-Senans et aux Salines de Salins-les-Bains (sites classés UNESCO). Située à seulement 40 minutes de ces lieux, la Villa Palladienne offre une immersion raffinée dans l'histoire des Maîtres de Forges. Si vous vous demandez quel musée visiter dans le Jura pour comprendre le lien entre industrie et art de vivre, Syam est la réponse évidente.",
    ms_visiter_faq_q3: "Quelle visite faire entre le Fort des Rousses et Lons-le-Saunier ?",
    ms_visiter_faq_a3: "Le domaine de Syam constitue l'escale parfaite sur la route entre Lons-le-Saunier et le Fort des Rousses. Profitez de votre passage vers la Région des Lacs et les Cascades du Hérisson pour découvrir ce palais privé. Avec ses audio-guides captivants et ses collections d'exception, c'est le lieu idéal pour une visite culturelle enrichissante au cœur du massif jurassien.",
    ms_visiter_faq_q4: "Comment s'organisent les visites du château et quels sont les horaires ?",
    ms_visiter_faq_a4: "La Villa est ouverte {jours_heures}, {periode}.{fermes_phrase} Nos visites sont audio-guidées pour une expérience immersive à votre rythme. Vous plongerez dans les secrets de cette demeure mythique avant de profiter d'une balade bucolique dans notre parc, situé au confluent de l'Ain et de la Saine.",
    ms_visiter_faq_q5: "Quelles randonnées faire à proximité du Château de Syam ?",
    ms_visiter_faq_a5: "Pour les amateurs de nature et randonnée dans le Jura, Syam est le point de départ idéal. Avant ou après votre visite du château, ne manquez pas les sites naturels spectaculaires à proximité immédiate :\n• Les Pertes de l'Ain (juste à côté)\n• Les Gorges de la Langouette\n• Les Cascades de la Billaude\nC'est la combinaison parfaite entre patrimoine bâti et sites naturels sauvages.",
    ms_visiter_faq_q6: "Le domaine est-il accessible avec des animaux ?",
    ms_visiter_faq_a6: "Nos amis à quatre pattes (chiens tenus en laisse) sont les bienvenus pour une promenade dans le parc. Cependant, pour des raisons de conservation des décors historiques, ils ne sont pas admis à l'intérieur de la villa. Les petits chiens tenus dans les bras ou dans un sac sont autorisés.",
    ms_visiter_faq_q7: "Pourquoi choisir Syam pour une sortie en famille dans le Jura ?",
    ms_visiter_faq_a7: "Bien plus qu'un simple musée, la Villa Palladienne est un \"musée vivant\". Ses volumes grandioses et ses anecdotes historiques captivent toutes les générations. C'est l'une des meilleures idées de sortie en famille dans le Jura pour varier les plaisirs entre les activités de plein air et la découverte du prestigieux patrimoine français.",
    chambre_amelie_seo_title: "Chambre Amélie — Château de Syam | Jura",
    chambre_amelie_seo_desc: "Chambre d'hôtes Amélie au Château de Syam : décor Empire, vue sur le parc, petit-déjeuner inclus. Réservez votre séjour dans ce monument historique du Jura.",
    chambre_helena_seo_title: "Chambre Héléna — Château de Syam | Jura",
    chambre_helena_seo_desc: "Chambre d'hôtes Héléna au Château de Syam : suite de charme, mobilier d'époque, petit-déjeuner inclus. Monument historique dans le Jura.",
    chambre_carnot_seo_title: "Chambre Carnot — Château de Syam | Jura",
    chambre_carnot_seo_desc: "Chambre d'hôtes Carnot au Château de Syam : chambre double de caractère, décor authentique. Petit-déjeuner inclus. Monument historique du Jura.",
    chambre_josephine_seo_title: "Chambre Joséphine — Château de Syam | Jura",
    chambre_josephine_seo_desc: "Chambre d'hôtes Joséphine au Château de Syam : suite romantique, mobilier Empire, petit-déjeuner inclus. Séjour d'exception dans le Jura.",
    chambre_eugenie_seo_title: "Suite Eugénie — Château de Syam | Jura",
    chambre_eugenie_seo_desc: "Suite Eugénie au Château de Syam : suite prestige, décor Empire, vue panoramique. Petit-déjeuner inclus. Monument historique du Jura.",
    offrir_seo_title: "Offrir le Château de Syam | Bons cadeaux Jura",
    offrir_seo_desc: "Bons cadeaux Château de Syam : visites, séjours, expériences. Cadeau original dans un monument néo-palladien classé. Jura.",
    gite_cesar_nl_description: "Gîte César is een onafhankelijke vakantiewoning in het kasteeldomein van Syam. Ideaal voor families en groepen, met een volledig uitgeruste keuken, woonkamer en privétuin.",
    gite_cesar_nl_infos: "Capaciteit: 6 personen\nSlaapkamers: 3\nBadkamers: 2\nPrivétuin\nVolledig uitgeruste keuken",
    gite_rosalie_nl_description: "Gîte Rosalie is een charmante vakantiewoning in het kasteeldomein van Syam. Rustiek en gezellig, met alle moderne comfort voor een onvergetelijk verblijf in de Jura.",
    gite_rosalie_nl_infos: "Capaciteit: 4 personen\nSlaapkamers: 2\nBadkamers: 1\nPrivéterras\nVolledig uitgeruste keuken",
    vis_info_horaires_titre: "Horaires",
    vis_info_horaires_texte: "Ouvert {periode}\n{liste_horaires}",
    vis_info_tarifs_titre: "Tarifs",
    vis_info_tarifs_texte: "Adulte : 12 €\nEnfant (–14 ans) : 5 €\nVisite audio-guidée libre (environ 1 h 30)",
    vis_info_tarifs_groupes_label: "Groupes :",
    vis_info_tarifs_groupes_cta: "Organiser votre visite",
    vis_info_acces_titre: "Accès",
    vis_info_acces_texte: "225 Chemin de Benaisy\n39300 Syam, Jura\n4 km de Champagnole\n1h de Besançon, Dijon, Lausanne et Genève",
    vis_info_contact_titre: "Contact",
    vis_info_contact_texte: "Tél : 03 84 51 64 14\nMobile : 06 87 54 14 57\ncontact@chateaudesyam.fr",
    vis_seo_title: "Château à visiter dans le Jura | Villa Palladienne, Monument Historique",
    vis_seo_description: "Château à visiter dans le Jura : découvrez la Villa Palladienne de Syam, unique villa néo-palladienne de France classée Monument Historique. Visite audio-guidée, décors du XIXe siècle, près des Cascades du Hérisson.",
    vis_seo_keywords: "château à visiter Jura, villa palladienne, monument historique Jura, visite culturelle Jura, Cascades du Hérisson",
    vis_hero_surtitle: "Monument Historique · Jura",
    vis_hero_title: "Visite du Château",
    vis_hero_subtitle: "Le château le plus visité de Franche-Comté",
    vis_infos_section_surtitle: "Informations",
    vis_infos_section_title: "Préparez votre visite",
    vis_archi_surtitle: "La visite",
    vis_archi_title: "Un chef-d’œuvre néo-palladien",
    vis_archi_title_line1: "Un chef-d’œuvre",
    vis_archi_title_line2: "néo‑palladien",
    vis_archi_text1: "Édifiée en 1818, la Villa Palladienne est une demeure au plan carré de 24 m × 24 m, centrée sur un péristyle de huit colonnes néoclassiques et trois balcons circulaires, dans l'esprit des villas italiennes du Maître Andréa Palladio. Elle est l'unique villa palladienne de France, classée Monument Historique depuis 1994.",
    vis_archi_text2: "La visite audio-guidée libre (environ 1 h 30) vous emmène à travers les salons ornés de papiers peints panoramiques du XIXe siècle, la rotonde à coupole de verre, les appartements meublés d'époque Empire, Restauration et Louis-Philippe — restés dans leur état d'origine.",
    vis_cta_surtitle: "Réservation",
    vis_cta_title: "Planifiez votre visite",
    vis_cta_text: "Visites individuelles sans réservation. Groupes et scolaires : contactez-nous pour organiser votre venue.",
    vis_horaire_ouverture: "{Periode}",
    vis_horaire_lun: "{h_lundi}",
    vis_horaire_mar: "{h_mardi}",
    vis_horaire_mer: "{h_mercredi}",
    vis_horaire_jeu: "{h_jeudi}",
    vis_horaire_ven: "{h_vendredi}",
    vis_horaire_sam: "{h_samedi}",
    vis_horaire_dim: "{h_dimanche}",
    vis_tarif_adulte: "12 €",
    vis_tarif_enfant: "5 €",
    vis_infos_hero_title: "Informations pratiques",
    vis_tarifs_note: "La visite de la Villa est audioguidée. Il convient de prévoir environ 1 h 30. Les audioguides sont inclus dans le prix.",
    vis_billetterie_commentaire: "Des visites commentées par les propriétaires sont proposées à certaines dates.",
    vis_billetterie_buy: "Acheter vos billets",
    vis_acces_titre: "Localisation",
    vis_acces_adresse_1: "225 Chemin de Benaisy",
    vis_acces_adresse_2: "39300 Syam, Jura",
    vis_acces_adresse_3: "Bourgogne-Franche-Comté",
    vis_acces_voiture_1: "A39 sortie Poligny (n°7)",
    vis_acces_voiture_2: "Puis D472 direction Champagnole",
    vis_acces_voiture_3: "4 km de Champagnole",
    vis_acces_train_1: "Gare de Champagnole (4 km)",
    vis_acces_train_2: "Gare de Poligny (15 km)",
    vis_acces_tel_1: "03 84 51 64 14",
    vis_acces_tel_2: "06 87 54 14 57",
    vis_acces_email: "contact@chateaudesyam.fr",
    vis_acces_itineraire: "Obtenir l'itinéraire",
    vis_cta_titre: "Préparez votre visite",
    vis_timeline_1_year: "1788",
    vis_timeline_1_title: "La libération du Grand Claude",
    vis_timeline_1_text: "L'histoire commence à Bellefontaine, dans le Haut-Jura. En 1788, le Grand Claude Jobez obtient sa liberté après des années de servitude. Avec une énergie et une ambition hors du commun, il va bâtir en quelques décennies l'un des plus grands empires industriels de Franche-Comté.",
    vis_timeline_2_year: "1800–1815",
    vis_timeline_2_title: "Claude Jobez, fournisseur de Napoléon",
    vis_timeline_2_text: "Libéré de la mainmorte des chanoines de Saint-Claude, Claude Jobez, fils du Grand Claude, d’abord paysan puis colporteur d’horloges comtoises, se lança dans les affaires en achetant les forges de Rochejean dans le Doubs, puis de Syam dans le Jura, où il construisit une usine très moderne et devint fournisseur de l’empereur Napoléon Bonaparte, qui lui commanda des épées et des baïonnettes pour les campagnes impériales. La fabrication d’armes pour la guerre lui permit de faire fortune et d’acquérir de nombreux biens nationaux. Ces succès permettront à son fils Jean Emmanuel d’édifier la Villa Palladienne après la succession.",
    vis_timeline_3_year: "1818",
    vis_timeline_3_title: "Jean Emmanuel Jobez bâtit la Villa Palladienne",
    vis_timeline_3_text: "Héritier de la fortune de son père, Jean Emmanuel Jobez fait construire à Syam une résidence d'exception : la Villa Palladienne. Inspirée des villas vénitiennes d'Andrea Palladio, cette demeure néo-classique de 24 m × 24 m, avec son péristyle de huit colonnes et sa rotonde à coupole de verre, est unique en France. Les meilleurs artisans et décorateurs de l'époque y travaillent pendant plusieurs années.",
    vis_timeline_4_year: "XIXe siècle",
    vis_timeline_4_title: "Les trésors décoratifs",
    vis_timeline_4_text: "La Villa abrite la plus importante collection de papiers peints et panoramiques du XIXe siècle de France. Ces œuvres d'art uniques — dont certaines représentent des scènes mythologiques, des paysages exotiques ou des vues de Paris — ornent les salons et les chambres dans leur état d'origine. S'y ajoutent des meubles Empire et Restauration, des portraits de famille et une collection d'objets d'art exceptionnels.",
    vis_timeline_5_year: "1994",
    vis_timeline_5_title: "Classement aux Monuments Historiques",
    vis_timeline_5_text: "La Villa Palladienne et son parc arborisé de 10 hectares sont classés aux Monuments Historiques. Cette reconnaissance officielle consacre l'importance architecturale et historique du domaine, et garantit sa préservation pour les générations futures.",
    vis_timeline_6_year: "Aujourd'hui",
    vis_timeline_6_title: "Un monument vivant ouvert à tous",
    vis_timeline_6_text: "Ouverte {periode} ({jours_heures_court}), la Villa Palladienne accueille chaque année des milliers de visiteurs. Visites audio-guidées, séjours en chambres d'hôtes, événements privés et mariages : le domaine de Syam est un lieu de vie et de culture unique en France.",
    dor_inclus_1: "Petit-déjeuner gourmand servi en chambre ou en terrasse selon la météo",
    dor_inclus_2: "Visite audio-guidée du château incluse pour chaque hôte",
    dor_inclus_3: "Parc arborisé de 10 hectares à votre disposition",
    dor_inclus_4: "Parking privé gratuit sur place",
    dor_inclus_5: "225 Chemin de Benaisy, 39300 Syam — 4 km de Champagnole",
    dor_inclus_6: "Réservation : 03 84 51 64 14 — 06 87 54 14 57",
    dor_chambre_amelie_nom: "Amélie",
    dor_chambre_amelie_desc: "Au deuxième étage, chambre de charme décorée dans le style du XIXe siècle. Papier peint de mythologie grecque, douche à l'italienne, cheminée et lit 280 × 200 cm.",
    dor_chambre_amelie_prix: "250 €",
    dor_chambre_helena_nom: "Héléna",
    dor_chambre_helena_desc: "Belle chambre romantique, ambiance XIXe siècle, au premier étage. Vue sur le parc du château, salle de bain privative avec douche et baignoire.",
    dor_chambre_helena_prix: "250 €",
    dor_chambre_carnot_nom: "Carnot",
    dor_chambre_carnot_desc: "Grande chambre au charme Empire, au premier étage, avec vue sur le parc. Salle de bain privative avec douche et baignoire.",
    dor_chambre_carnot_prix: "250 €",
    dor_chambre_josephine_nom: "Joséphine",
    dor_chambre_josephine_desc: "Magnifique et grande chambre au premier étage, au décor authentique de la manufacture Zuber : papier peint panoramique aux scènes champêtres, vue magnifique, cheminée et piano.",
    dor_chambre_josephine_prix: "250 €",
    dor_chambre_eugenie_nom: "Eugénie",
    dor_chambre_eugenie_desc: "Au deuxième étage, très grande chambre avec vue magnifique sur le Fer à Cheval. Lit à baldaquin 180 × 300 cm, soieries or et bleu.",
    dor_chambre_eugenie_prix: "250 €",
    dor_seo_title: "Chambres d'hôtes dans un château du Jura | Château de Syam",
    dor_seo_description: "Chambres d'hôtes au Château de Syam : cinq chambres de charme dans une Villa Palladienne classée, petit-déjeuner et visite inclus. Dormir dans un monument historique du Jura près de Champagnole.",
    dor_seo_keywords: "chambres d'hôtes château Jura, dormir dans un château, hébergement de charme Jura, week-end romantique Jura, Champagnole",
    dor_hero_surtitle: "Chambres d'hôtes · Château de Syam",
    dor_hero_title: "Dormir au Château",
    dor_hero_subtitle: "Vivez une nuit d'exception dans un monument historique du Jura",
    dor_infos_title: "Ouvert {periode}",
    dor_infos_text: "Château de Syam · 39300 Syam, Jura\nTél : 03 84 51 64 14 / 06 87 54 14 57",
    dor_tarif_carnot: "250 € / nuit",
    dor_tarif_helena: "250 € / nuit",
    dor_tarif_syamour: "250 € / nuit",
    dor_tarif_eugenie: "250 € / nuit",
    dor_tarif_palladio: "250 € / nuit",
    dor_tarif_pdj: "Inclus",
    dor_tarif_visite: "Incluse",
    dor_tarif_taxe: "1,50 € / pers. / nuit",
    dor_checkin: "À partir de 16h00",
    dor_checkout: "Avant 11h00",
    dor_pdj_horaire: "8h00 – 10h00",
    dor_saison: "{Periode_complete}",
    dor_sejour_min: "1 nuit",
    dor_reservation_info: "Via Smoobu ou contact direct",
    dor_infos_inclus_1: "Petit-déjeuner gourmand servi en chambre ou en terrasse",
    dor_infos_inclus_2: "Visite audio-guidée du château incluse",
    dor_infos_inclus_3: "Accès libre au parc de 10 hectares",
    dor_infos_inclus_4: "Parking privé gratuit",
    dor_infos_inclus_5: "Wi-Fi haut débit",
    dor_infos_inclus_6: "Salle de bain privée pour chaque chambre",
    dor_infos_inclus_7: "Verre de bienvenue à l'arrivée",
    dor_infos_inclus_8: "Conseils et carte des activités du Jura",
    dor_regle_1: "Les chambres d'hôtes sont situées dans le château classé monument historique. Nous vous demandons de respecter le lieu et son histoire.",
    dor_regle_2: "Fumer est strictement interdit à l'intérieur du château. Un espace fumeurs est disponible dans le parc.",
    dor_regle_3: "Les animaux de compagnie ne sont pas acceptés dans les chambres d'hôtes.",
    dor_regle_4: "Le calme est demandé après 22h afin de respecter les autres hôtes.",
    dor_regle_5: "En cas d'annulation moins de 48h avant l'arrivée, une nuit sera facturée.",
    dor_regle_6: "Le petit-déjeuner est servi entre 8h et 10h. Merci de nous indiquer vos préférences alimentaires à l'avance.",
    dor_infos_hero_label: "Chambres d'hôtes · Château de Syam",
    dor_infos_hero_title: "Informations pratiques",
    dor_tarifs_titre: "Nos 5 chambres",
    dor_horaires_titre: "Horaires",
    dor_inclus_titre: "Une expérience complète",
    dor_regle_titre: "Bon à savoir",
    dor_cta_titre: "Réservez votre nuit au château",
    dor_cta_btn_1: "Réserver en ligne",
    git_cesar_nom: "Gîte César",
    git_cesar_desc: "Appartement duplex pour 5 personnes maximum. 2 chambres, cuisine équipée, séjour lumineux, salle de bain et WC séparé. Terrasse ombragée avec mobilier de jardin et barbecue.",
    git_cesar_prix: "440 €",
    git_cesar_details: "Max. 5 personnes|2 chambres (duplex)|Minimum 2 nuits|Linge de maison inclus|Forfait ménage 50 €",
    git_rosalie_nom: "Gîte Rosalie",
    git_rosalie_desc: "Grand appartement duplex pour 9 personnes maximum. 4 chambres, cuisine équipée, grand séjour, 2 salles de bain, 2 WC. Terrasse ombragée avec mobilier de jardin et barbecue.",
    git_rosalie_prix: "600 €",
    git_rosalie_details: "Max. 9 personnes|4 chambres (duplex)|Minimum 2 nuits|Linge de maison inclus|Forfait ménage 50 €",
    git_seo_title: "Location de gîtes dans le Jura | Château de Syam près des Cascades du Hérisson",
    git_seo_description: "Louez les gîtes César et Rosalie au Château de Syam : hébergements indépendants pour familles et groupes, parc et patrimoine. Séjour en gîte dans le Jura, près de Champagnole.",
    git_seo_keywords: "location gîte Jura, gîte château Jura, hébergement famille Jura, séjour groupe Jura, Champagnole",
    git_hero_surtitle: "Gîtes · Château de Syam",
    git_hero_title: "Nos Gîtes",
    git_hero_subtitle: "Séjournez en toute indépendance dans le domaine du château",
    git_infos_minimum: "Séjour minimum 2 nuits",
    git_infos_checkin: "Disponibles {periode}",
    git_tarif_cesar: "440 € / nuit",
    git_tarif_rosalie: "600 € / nuit",
    git_sejour_min: "2 nuits",
    git_jours_dispo: "Dim. → Ven. (pas de sam.)",
    git_forfait_menage: "50 € en sus",
    git_linge: "Inclus",
    git_ouverture: "{Mois_debut}",
    git_fermeture: "{Fin_saison} inclus",
    git_arrivee: "À partir de 16h00",
    git_depart: "Avant 11h00",
    git_reservation_info: "Via Smoobu ou contact direct",
    git_equip_1: "Cuisine entièrement équipée",
    git_equip_2: "TV écran plat",
    git_equip_3: "Wi-Fi haut débit",
    git_equip_4: "Linge de lit fourni",
    git_equip_5: "Serviettes de bain",
    git_equip_6: "Terrasse ou jardin privatif",
    git_equip_7: "Parking privé",
    git_equip_8: "Visite de la Villa possible sur Rendez-vous",
    git_equip_9: "Accès parc 10 ha",
    git_equip_10: "Animaux acceptés (30 € par séjour)",
    git_regle_1: "Séjour minimum de 2 nuits. Semaine complète possible avec tarif dégressif.",
    git_regle_2: "Les animaux de compagnie sont acceptés. Un supplément de 30 € par séjour est demandé.",
    git_regle_3: "Fumer est interdit à l'intérieur des gîtes. Un espace fumeurs est disponible à l'extérieur.",
    git_regle_4: "Les gîtes sont des espaces privés indépendants. Le calme et le respect du voisinage sont demandés.",
    git_regle_5: "En cas d'annulation, merci de nous prévenir au moins 7 jours avant l'arrivée pour un remboursement complet.",
    git_regle_6: "L'état des lieux est réalisé à l'arrivée et au départ. Tout dommage constaté sera facturé.",
    git_infos_hero_label: "Gîtes · Château de Syam",
    git_infos_hero_title: "Informations pratiques",
    git_tarifs_titre: "Gîte César & Rosalie",
    git_dispos_titre: "Saison",
    git_equip_titre: "Gîtes confortables et bien équipés",
    git_regle_titre: "Bon à savoir",
    git_cta_titre: "Réservez votre séjour",
    git_cta_btn_1: "Réserver en ligne",
    off_offre_1_titre: "Formule Découverte",
    off_offre_1_desc: "Offrez une visite audio-guidée de la Villa Palladienne, Monument Historique classé. Papiers peints panoramiques, rotonde à coupole de verre, mobilier d'époque.",
    off_offre_1_prix: "12 €",
    off_offre_1_detail: "Adulte · Visite audio-guidée · Ouvert {periode}",
    off_offre_1_note: "Enfants (moins de 12 ans) : 5 €",
    off_offre_2_titre: "Formule Classique",
    off_offre_2_desc: "Une nuit pour 2 dans une chambre d'hôtes du château (Amélie, Héléna, Carnot, Joséphine ou Eugénie) avec petit-déjeuner gourmand et visite audio-guidée inclus.",
    off_offre_2_prix: "250 €",
    off_offre_2_detail: "1 nuit pour 2 · 2 petits-déjeuners · 2 visites incluses",
    off_offre_3_titre: "Formule Prestige",
    off_offre_3_desc: "Une nuit pour un couple avec 2 petits-déjeuners gourmands et dîner romantique dans une auberge toute proche.",
    off_offre_3_prix: "380 €",
    off_offre_3_detail: "1 nuit pour 2 · Dîner romantique · Petit-déjeuner · Visite incluse",
    off_seo_title: "Formule cadeau dans le Jura | Château de Syam — visite, séjour et expérience",
    off_seo_description: "Offrez une formule cadeau au Château de Syam dans le Jura : visite audio-guidée, nuit en chambre d'hôtes ou séjour. Idée cadeau anniversaire, Noël, Saint-Valentin ou couple.",
    off_seo_keywords: "formule cadeau Jura, cadeau château, idée cadeau anniversaire, cadeau Noël, Saint-Valentin",
    off_hero_surtitle: "Formules cadeaux · Château de Syam",
    off_hero_title: "Plaisir d'Offrir",
    off_hero_subtitle: "Anniversaires, Noël, Saint-Valentin, offrez à ceux que vous aimez une expérience unique",
    off_offres_title: "Des expériences à offrir",
    off_cta_title: "Un cadeau sur mesure",
    off_cta_text: "Vous souhaitez une offre personnalisée ? Contactez-nous pour créer une formule cadeau unique.",
    mar_atout_1_titre: "170 m² de salle de réception",
    mar_atout_1_desc: "Salle de réception de 170 m² avec cuisine professionnelle et terrasse partiellement couverte plein ouest.",
    mar_atout_2_titre: "Jusqu'à 150 convives",
    mar_atout_2_desc: "Les dépendances en Fer à Cheval restaurées accueillent jusqu'à 150 convives dans un cadre romantique et élégant.",
    mar_atout_3_titre: "Parc de 10 hectares",
    mar_atout_3_desc: "Grande terrasse au charme incomparable s'ouvrant sur un parc arborisé de 10 hectares pour cérémonie en plein air.",
    mar_atout_4_titre: "70 personnes sur place",
    mar_atout_4_desc: "Hébergement pour 70 personnes en Chambres d'Hôtes à la Villa et en Gîtes au Fer à Cheval.",
    mar_atout_5_titre: "Demander un Devis",
    mar_atout_5_desc: "Contactez-nous pour recevoir un devis personnalisé adapté à votre projet de mariage.",
    mar_atout_6_titre: "Cadre photographique d'exception",
    mar_atout_6_desc: "Architecture néo-palladienne, jardins et intérieurs d'époque classés Monument Historique pour des photos inoubliables.",
    mar_seo_title: "Château pour mariage dans le Jura | Lieu de réception Bourgogne-Franche-Comté",
    mar_seo_description: "Lieu de mariage dans le Jura : Château de Syam, monument historique avec salle de réception de 170 m², parc de 10 ha et hébergements. À proximité de Genève, Besançon et Dijon.",
    mar_seo_keywords: "château mariage Jura, lieu mariage Jura, lieu réception Bourgogne-Franche-Comté, mariage proche Genève",
    mar_hero_surtitle: "Mariages & Réceptions · Château de Syam",
    mar_brochure_postal_code: "Code postal",
    mar_brochure_wedding_period: "Période ou date du mariage envisagée",
    mar_contact_estimated_guests: "Nombre de personnes estimé",
    mar_contact_wedding_period: "Période pressentie pour le mariage",
    mar_hero_title: "Se Marier au Château",
    mar_hero_subtitle: "Un cadre d'exception pour le plus beau jour de votre vie",
    mar_atouts_surtitle: "Le cadre idéal",
    mar_atouts_title: "Un château pour votre mariage",
    mar_cta_title: "Contactez-nous",
    mar_cta_text: "La location des dépendances inclut la salle de réception (170 m² + cuisine professionnelle), la terrasse et l'accès au parc. Hébergement en option.",
    grp_formule_1_titre: "Visite audioguidée en français, anglais, allemand et néerlandais",
    grp_formule_1_desc: "Visite de la Villa Palladienne avec audio-guide pour votre groupe. Découvrez les papiers peints panoramiques, la rotonde à coupole de verre et les appartements meublés d'époque.",
    grp_formule_1_details: "Tarif adulte : 12 €|Enfant (moins de 14 ans) : 5 €|Ouvert {periode}, {jours_heures_court}{fermes_court_paren}|Groupes : nous contacter",
    grp_formule_2_titre: "Séjour en groupe — Gîtes",
    grp_formule_2_desc: "Privatisez les gîtes César (5 pers.) et Rosalie (9 pers.) pour un séjour en groupe. Idéal pour familles, associations et groupes d'amis.",
    grp_formule_2_details: "Gîte César : 440 €/nuit (max. 5 pers.)|Gîte Rosalie : 600 €/nuit (max. 9 pers.)|Minimum 2 nuits · Dim. → Ven.",
    grp_formule_3_titre: "Réception & événement privé",
    grp_formule_3_desc: "Privatisez les dépendances en Fer à Cheval pour votre événement de groupe. Salle de réception 170 m², cuisine professionnelle, terrasse.",
    grp_formule_3_details: "Jusqu'à 150 convives|Salle 170 m² + cuisine professionnelle|Devis sur demande",
    grp_seo_title: "Visite de groupe dans le Jura | Château de Syam — scolaires, associations et autocaristes",
    grp_seo_description: "Organisez une visite de groupe au Château de Syam dans le Jura : groupes touristiques, scolaires, associations et autocaristes. Visites, séjours et journées découverte sur mesure.",
    grp_seo_keywords: "visite groupe Jura, sortie scolaire Jura, autocariste Jura, association Jura, journée découverte",
    grp_hero_surtitle: "Château de Syam · Jura",
    grp_hero_title: "Groupes",
    grp_hero_subtitle: "Visites guidées, séjours et journées découvertes\npour groupes, familles et associations",
    grp_formules_surtitle: "Nos formules",
    grp_formules_title: "Une expérience sur mesure",
    eve_espace_1_nom: "Dépendances en Fer à Cheval",
    eve_espace_1_cap: "Jusqu'à 150 personnes",
    eve_espace_1_desc: "Salle de réception de 170 m² avec cuisine professionnelle et terrasse partiellement couverte. Idéal pour séminaires, galas et réceptions.",
    grp_audioguide_titre: "Visite audioguidée en français, anglais, allemand et néerlandais",
    grp_audioguide_desc: "Environ 1 h 30.",
    eve_espace_2_nom: "Parc arborisé de 10 hectares",
    eve_espace_2_cap: "Espaces extérieurs",
    eve_espace_2_desc: "Grande terrasse au charme incomparable s'ouvrant sur un parc de 10 hectares. Parfait pour cocktails, cérémonies en plein air et shootings photo.",
    eve_espace_3_nom: "La Villa Palladienne",
    eve_espace_3_cap: "Visite privée incluse",
    eve_espace_3_desc: "Monument Historique classé en 1994. Papiers peints panoramiques du XIXe siècle, rotonde à coupole de verre, mobilier d'époque. Visite privée pour vos invités.",
    eve_type_1: "Séminaires & team-building",
    eve_type_2: "Dîners de gala & soirées de prestige",
    eve_type_3: "Lancements de produits",
    eve_type_4: "Réceptions privées & anniversaires",
    eve_type_5: "Tournages & shootings photo",
    eve_type_6: "Conférences & présentations",
    eve_types_title: "Vos événements sur mesure",
    eve_seo_title: "Séminaire dans un château du Jura | Événements d'entreprise au Château de Syam",
    eve_seo_description: "Lieu de séminaire dans le Jura : Château de Syam pour réunions, team building, galas et événements d'entreprise. Espaces jusqu'à 200 personnes, parc de 10 ha, près de Genève, Besançon et Dijon.",
    eve_seo_keywords: "séminaire château Jura, lieu séminaire Jura, événement entreprise Jura, team building Jura, réception entreprise",
    eve_hero_surtitle: "Événements & Séminaires · Château de Syam",
    eve_hero_title: "Événements d'Exception",
    eve_hero_subtitle: "Séminaires, lancements de produits, galas et événements privés dans un cadre unique",
    eve_espaces_title: "Des espaces pour chaque événement",
    eve_cta_title: "Organisez votre événement",
    eve_cta_text: "Chaque événement est unique. Contactez-nous pour un devis sur mesure adapté à vos besoins.",
    ros_seo_title: "Roseraie du Château de Syam | Jardin de roses et parc à visiter dans le Jura",
    ros_seo_description: "Découvrez la roseraie du Château de Syam, jardin de roses au cœur d'un parc de 10 hectares dans le Jura. Une étape patrimoniale et florale à visiter près de Champagnole.",
    ros_seo_keywords: "roseraie Jura, jardin de roses Jura, parc floral Jura, jardin à visiter Jura, Château de Syam",
    ros_hero_surtitle: "Paradis des fleurs · Château de Syam · Jura",
    ros_hero_title: "La Roseraie",
    ros_hero_tagline: "Paradis des fleurs au cœur du Jura",
    ros_hero_subtitle: "Un véritable paradis des fleurs niché dans un parc de 10 hectares.\nAllées de gravier, bassins, roses anciennes et modernes.",
    vis_galerie_seo_title: "Galerie photos — Visiter le Château de Syam",
    vis_galerie_title: "La Villa en images",
    vis_galerie_subtitle: "Galerie — Visiter",
    vis_contact_seo_title: "Contact & Renseignements — Visiter le Château de Syam",
    vis_contact_title: "Contact & Renseignements",
    vis_contact_subtitle: "Contact — Visiter",
    vis_contact_intro: "Visites individuelles sans réservation. Pour les groupes, scolaires ou visites privées, contactez-nous par formulaire ou téléphone.",
    dor_galerie_seo_title: "Galerie photos — Chambres d'hôtes au Château de Syam",
    dor_galerie_title: "Nos chambres & espaces",
    dor_galerie_subtitle: "Galerie — Dormir",
    dor_contact_seo_title: "Contact & Réservation — Chambres d'hôtes Château de Syam",
    dor_contact_title: "Contact & Renseignements",
    dor_contact_subtitle: "Contact — Dormir",
    git_galerie_seo_title: "Galerie photos — Gîtes du Château de Syam",
    git_galerie_title: "Nos gîtes en images",
    git_galerie_subtitle: "Galerie — Gîtes",
    git_contact_seo_title: "Contact & Réservation — Gîtes du Château de Syam",
    git_contact_title: "Contact & Renseignements",
    git_contact_subtitle: "Contact — Gîtes",
    git_contact_intro: "Pour louer nos gîtes César ou Rosalie, contactez-nous par formulaire ou téléphone. La réservation se finalise via notre module en ligne.",
    off_galerie_seo_title: "Galerie photos — Formules cadeaux Château de Syam",
    off_galerie_title: "Découvrez nos espaces",
    off_galerie_subtitle: "Galerie — Offrir",
    off_contact_seo_title: "Commander une formule cadeau — Château de Syam",
    off_contact_title: "Contact & Renseignements",
    off_contact_subtitle: "Contact — Offrir",
    off_contact_intro: "Pour commander une formule cadeau ou obtenir des informations sur nos offres, contactez-nous par formulaire ou téléphone.",
    mar_galerie_seo_title: "Galerie photos — Mariage au Château de Syam",
    mar_galerie_title: "Mariages au château",
    mar_galerie_subtitle: "Galerie — Mariage",
    mar_contact_seo_title: "Demande de devis — Mariage au Château de Syam",
    mar_contact_title: "Contact & Devis",
    mar_contact_subtitle: "Contact — Mariage",
    mar_contact_intro: "Partagez vos envies, nous vous répondons sous 48h avec une proposition personnalisée pour votre mariage au château.",
    eve_galerie_seo_title: "Galerie photos — Événements au Château de Syam",
    eve_galerie_title: "Le domaine en images",
    eve_galerie_subtitle: "Galerie — Événements",
    eve_contact_seo_title: "Contact Événements — Château de Syam",
    eve_contact_title: "Contact & Renseignements",
    eve_contact_subtitle: "Contact — Événements",
    grp_contact_seo_title: "Contact Groupes — Château de Syam",
    grp_contact_title: "Contact & Renseignements",
    grp_contact_subtitle: "Contact — Groupes",
    eve_contact_seo_title2: "Demande de devis — Événement au Château de Syam",
    eve_contact_title2: "Contact & Devis",
    eve_contact_intro: "Séminaires, galas, lancements de produit... Décrivez votre projet, nous vous répondons sous 48h avec une proposition sur mesure.",
    vis_acces_transport_titre: "Comment venir",
    vis_acces_voiture_titre: "En voiture",
    vis_acces_train_titre: "En train",

    vis_horaire_label_ouverture: "Ouverture",
    vis_horaire_label_lun: "Lundi",
    vis_horaire_label_mar: "Mardi",
    vis_horaire_label_mer: "Mercredi",
    vis_horaire_label_jeu: "Jeudi",
    vis_horaire_label_ven: "Vendredi",
    vis_horaire_label_sam: "Samedi",
    vis_horaire_label_dim: "Dimanche",
    vis_tarif_label_adulte: "Adulte",
    vis_tarif_label_enfant: "Enfant (–14 ans)",
    vis_acces_adresse_titre: "Adresse",
    vis_infos_seo_title: "Informations pratiques — Visiter le Château de Syam",
    vis_infos_seo_desc: "Horaires, tarifs, accès et informations pratiques pour visiter le Château de Syam dans le Jura.",
    vis_cta_decouvrir: "Découvrir",
    vis_cta_organiser: "Organiser votre visite",
    grp_sous1_titre: "Autocaristes & Tour-opérateurs",
    grp_sous1_desc: "Un arrêt incontournable sur les circuits touristiques du Jura. La Villa Palladienne, unique en France, offre une expérience culturelle exceptionnelle à vos clients. Devis rapide, accès car facilité, gratuit pour les chauffeurs.",
    grp_sous2_titre: "Associations & Clubs",
    grp_sous2_desc: "Clubs du 3ème âge, associations culturelles, comités d'entreprise — organisez une sortie mémorable dans un cadre exceptionnel. Visite audio-guidée, pause dans le parc, ambiance conviviale garantie.",
    grp_sous3_titre: "Groupes Scolaires",
    grp_sous3_desc: "Du primaire au lycée, le Château de Syam est un support pédagogique idéal pour l'histoire de l'art, l'architecture néo-classique et le patrimoine jurassien. Tarifs adaptés, programme sur mesure.",
    language_loading: "Chargement de la langue",
  };

export default translations;
